import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Upload: { input: any; output: any; }
};

export type Address = {
  /** Name of city or city district (ex. København K) */
  city: Scalars['String']['output'];
  /** Residence door if building or floor has multiple doors (ex. TH) */
  door?: Maybe<Scalars['String']['output']>;
  /** Residence floor if building has multiple floors (ex. 1.) */
  floor?: Maybe<Scalars['String']['output']>;
  /** House number on street (ex. 24A) */
  houseNumber: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  /** City postal code (ex. 2800) */
  postalCode: Scalars['String']['output'];
  /** Name of street without house number (ex. Vesterbrogade) */
  street: Scalars['String']['output'];
};

export type AddressInput = {
  /** Name of city or city district (ex. København K) */
  city: Scalars['String']['input'];
  /** Residence door if building or floor has multiple doors (ex. TH) */
  door?: InputMaybe<Scalars['String']['input']>;
  /** Residence floor if building has multiple floors (ex. 1.) */
  floor?: InputMaybe<Scalars['String']['input']>;
  /** House number on street (ex. 24A) */
  houseNumber: Scalars['String']['input'];
  /** City postal code (ex. 2800) */
  postalCode: Scalars['String']['input'];
  /** Name of street without house number (ex. Vesterbrogade) */
  street: Scalars['String']['input'];
};

export type AllOfferSavings = {
  disclaimer: Scalars['String']['output'];
  residence?: Maybe<SimpleResidenceResult>;
  results: Array<OfferSavingsWithProducts>;
};

export type AssortedOfferInput = {
  assortedProducts: Array<ProductInput>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Int']['input']>;
  expenses?: InputMaybe<Array<OfferExpenseInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reservations?: InputMaybe<Scalars['String']['input']>;
  withoutInstallation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssortedProduct = {
  brand: Scalars['String']['output'];
  buyPrice?: Maybe<Scalars['Float']['output']>;
  datasheetUrl?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Float']['output']>;
  descriptionId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Float']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  offerID?: Maybe<Scalars['Float']['output']>;
  price: Scalars['Float']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  size: HeatPumpSize;
};

export type AssortedProductInput = {
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String']['input'];
  buyPrice?: InputMaybe<Scalars['Float']['input']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Float']['input']>;
  descriptionId?: InputMaybe<Scalars['Int']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  model: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type AuthProvider = {
  type: AuthProviderType;
  userID: Scalars['String']['output'];
};

export type AuthProviderType =
  | 'google';

export type BankCustomerLead = {
  address: AddressInput;
  /** Bank branch at which customer advisor works */
  advisorBranch?: InputMaybe<Scalars['String']['input']>;
  /** Email of advisor assigned to customer */
  advisorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Name of advisor assigned to customer */
  advisorName?: InputMaybe<Scalars['String']['input']>;
  /** Any comments that might be relevant */
  comments?: InputMaybe<Scalars['String']['input']>;
  desiredProducts?: InputMaybe<Array<LeadProductTypeEnum>>;
  /** Customer email address */
  email: Scalars['String']['input'];
  /** Given first name(s) */
  firstName: Scalars['String']['input'];
  /** Legal surname */
  lastName: Scalars['String']['input'];
  /** Phone number including country code (+45) */
  phoneNumber: Scalars['String']['input'];
  /** Universally unique lead identifier */
  uuid: Scalars['String']['input'];
};

export type Battery = {
  brand: Scalars['String']['output'];
  buyPrice?: Maybe<Scalars['Float']['output']>;
  capacity: Scalars['Float']['output'];
  customerEnabled?: Maybe<Scalars['Boolean']['output']>;
  datasheetUrl?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Float']['output']>;
  descriptionId?: Maybe<Scalars['Int']['output']>;
  efficiency: Scalars['Float']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  offerID?: Maybe<Scalars['Float']['output']>;
  preferred?: Maybe<Scalars['Boolean']['output']>;
  price: Scalars['Float']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  size: HeatPumpSize;
  warrantyCycles?: Maybe<Scalars['Int']['output']>;
  warrantyYears?: Maybe<Scalars['Int']['output']>;
  webshopEnabled?: Maybe<Scalars['Boolean']['output']>;
  weight: Scalars['Float']['output'];
};

export type BatteryInput = {
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String']['input'];
  buyPrice?: InputMaybe<Scalars['Float']['input']>;
  capacity: Scalars['Float']['input'];
  customerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Float']['input']>;
  descriptionId?: InputMaybe<Scalars['Int']['input']>;
  efficiency: Scalars['Float']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  model: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
  price: Scalars['Float']['input'];
  warrantyCycles?: InputMaybe<Scalars['Int']['input']>;
  warrantyYears?: InputMaybe<Scalars['Int']['input']>;
  webshopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  weight: Scalars['Float']['input'];
};

export type BatteryProductRange = {
  batteries: Array<Battery>;
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type BatteryRangeInput = {
  batteryIDs: Array<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type BbrPrimaryHeating = {
  annualUsage: Scalars['Float']['output'];
  efficiency?: Maybe<Scalars['Float']['output']>;
  fuelSubtype?: Maybe<Scalars['String']['output']>;
  fuelType: Scalars['String']['output'];
  heatSource?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  volumeUnit?: Maybe<Scalars['String']['output']>;
};

export type BbrResidence = {
  area: Scalars['Float']['output'];
  areaHeated: Scalars['Float']['output'];
  areaNotHeated?: Maybe<Scalars['Int']['output']>;
  areaPartiallyHeated?: Maybe<Scalars['Float']['output']>;
  builtYear?: Maybe<Scalars['Float']['output']>;
  consumption?: Maybe<Consumption>;
  energyExpenditure: Scalars['Float']['output'];
  energyLabel?: Maybe<EnergyLabelEnum>;
  floors: Scalars['Float']['output'];
  heatDistribution?: Maybe<HeatDistributionTypeEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  primaryHeating?: Maybe<BbrPrimaryHeating>;
  renovatedDegree?: Maybe<RenovationDegreeEnum>;
  renovatedYear?: Maybe<Scalars['Float']['output']>;
  residents?: Maybe<Scalars['Float']['output']>;
  roofs?: Maybe<Array<Roof>>;
  secondaryHeating?: Maybe<BbrSecondaryHeating>;
  type: ResidenceType;
  waterConsumption: WaterConsumptionDegreeEnum;
};

export type BbrSecondaryHeating = {
  heatSource?: Maybe<Scalars['String']['output']>;
};

export type BoxSize = {
  depth: Scalars['Float']['output'];
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type BoxSizeInput = {
  depth: Scalars['Float']['input'];
  height: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type CrmCustomer = {
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CrmCustomerFields = {
  address?: Maybe<Scalars['String']['output']>;
  assignedAdvisor?: Maybe<Scalars['String']['output']>;
  financialAdvisor?: Maybe<Scalars['String']['output']>;
  leadOrigin?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type CompositeFigure = {
  floor: Scalars['Float']['output'];
  radiator: Scalars['Float']['output'];
};

export type CompositeLabel = {
  floor: Scalars['String']['output'];
  radiator: Scalars['String']['output'];
};

export type Constant = {
  code: Scalars['String']['output'];
  denominator?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  numerator: Scalars['String']['output'];
  valueNumber: Scalars['Float']['output'];
};

export type ConstantInput = {
  code: Scalars['String']['input'];
  denominator?: InputMaybe<Scalars['String']['input']>;
  numerator: Scalars['String']['input'];
  valueNumber: Scalars['Float']['input'];
};

export type Consumption = {
  profileKey: ConsumptionProfile;
  profileValue: Array<Scalars['Float']['output']>;
};

export type ConsumptionProfile =
  | 'homeAt17'
  | 'homeEveryDay'
  | 'homeInAfternoon'
  | 'homeInMorning'
  | 'homeMostDays'
  | 'industrialConsumption';

export type Customer = {
  assignedAdvisor?: Maybe<User>;
  assignedAdvisorId?: Maybe<Scalars['Int']['output']>;
  callBackAt?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Float']['output'];
  eligibleForFinancing: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  financialAdvisor?: Maybe<Scalars['String']['output']>;
  financingProvider?: Maybe<CustomerFinancingProvider>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  includeHeatPumpSubsidy?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadOrigin?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  newsletter?: Maybe<Scalars['Boolean']['output']>;
  norlysPromotion?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  numberOfOffers?: Maybe<Scalars['Int']['output']>;
  ownerID?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Float']['output']>;
  usePriceInflation?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerFinancingProvider =
  | 'jyskebank'
  | 'nordea';

export type CustomerInput = {
  assignedAdvisorId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  financialAdvisor?: InputMaybe<Scalars['String']['input']>;
  financingProvider?: InputMaybe<CustomerFinancingProvider>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleClickId?: InputMaybe<Scalars['String']['input']>;
  includeHeatPumpSubsidy?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leadOrigin?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  norlysPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  scoringFields?: InputMaybe<ScoringFields>;
  usePriceInflation?: InputMaybe<Scalars['Boolean']['input']>;
  utmFields?: InputMaybe<UtmFields>;
};

export type CylinderSize = {
  diameter: Scalars['Float']['output'];
  height: Scalars['Float']['output'];
};

export type CylinderSizeInput = {
  diameter: Scalars['Float']['input'];
  height: Scalars['Float']['input'];
};

export type DataConsentInput = {
  consented: Scalars['Boolean']['input'];
  partner: DataConsentPartner;
};

export type DataConsentPartner =
  | 'edc'
  | 'jyskebank'
  | 'nordea'
  | 'norlys';

export type ElectricCar = {
  annualKilometersDriven: Scalars['Int']['output'];
  consumptionPerKilometer: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isSubsidised?: Maybe<Scalars['Boolean']['output']>;
  monthlySubscriptionPrice?: Maybe<Scalars['Float']['output']>;
  percentageCharged: Scalars['Int']['output'];
};

export type ElectricCarInput = {
  annualKilometersDriven: Scalars['Int']['input'];
  consumptionPerKilometer: Scalars['Int']['input'];
  isSubsidised?: InputMaybe<Scalars['Boolean']['input']>;
  monthlySubscriptionPrice?: InputMaybe<Scalars['Float']['input']>;
  percentageCharged: Scalars['Int']['input'];
};

export type EnergyLabelEnum =
  | 'A2010'
  | 'A2015'
  | 'A2020'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G';

export type EnergyLabels = {
  before: Scalars['String']['output'];
  both?: Maybe<Scalars['String']['output']>;
  heatPump?: Maybe<Scalars['String']['output']>;
  solar?: Maybe<Scalars['String']['output']>;
};

export type ExpenseAutomation = {
  condition: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type ExpenseAutomationInput = {
  condition: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type FuelType =
  | 'districtHeating'
  | 'electricity'
  | 'gas'
  | 'oil'
  | 'pallet'
  | 'straw'
  | 'wood';

export type HeatDistributionTypeEnum =
  | 'floor'
  | 'radiator'
  | 'radiatorAndFloor';

export type HeatPumpApp =
  | 'addition'
  | 'nibe'
  | 'unknown'
  | 'yes';

export type HeatPumpIndoorUnit = {
  app: HeatPumpApp;
  brand: Scalars['String']['output'];
  buffer: Scalars['Float']['output'];
  buyPrice?: Maybe<Scalars['Float']['output']>;
  customerEnabled?: Maybe<Scalars['Boolean']['output']>;
  datasheetUrl?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Float']['output']>;
  descriptionId?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  internet: HeatPumpInternet;
  model: Scalars['String']['output'];
  noiseLevel: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  offerID?: Maybe<Scalars['Float']['output']>;
  power?: Maybe<Scalars['String']['output']>;
  preferred?: Maybe<Scalars['Boolean']['output']>;
  price: Scalars['Float']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  size: HeatPumpSize;
  solutionType: IndoorUnitSolutionType;
  waterVolume: Scalars['Float']['output'];
  webshopEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type HeatPumpIndoorUnitInput = {
  app: HeatPumpApp;
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String']['input'];
  buffer: Scalars['Float']['input'];
  buyPrice?: InputMaybe<Scalars['Float']['input']>;
  customerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Float']['input']>;
  descriptionId?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  internet: HeatPumpInternet;
  model: Scalars['String']['input'];
  noiseLevel: Scalars['Float']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  power?: InputMaybe<Scalars['String']['input']>;
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
  price: Scalars['Float']['input'];
  solutionType?: InputMaybe<IndoorUnitSolutionType>;
  waterVolume: Scalars['Float']['input'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeatPumpInternet =
  | 'LAN'
  | 'unknown'
  | 'wifi'
  | 'wifiAddition';

export type HeatPumpOfferInput = {
  chosenHeating?: InputMaybe<Scalars['Float']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Int']['input']>;
  expenses?: InputMaybe<Array<OfferExpenseInput>>;
  heatPumpIndoorProduct?: InputMaybe<ProductInput>;
  heatPumpOutdoorProduct?: InputMaybe<ProductInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reservations?: InputMaybe<Scalars['String']['input']>;
  withoutInstallation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeatPumpOutdoorUnit = {
  brand: Scalars['String']['output'];
  buyPrice?: Maybe<Scalars['Float']['output']>;
  compatibleIndoorUnits: Array<Scalars['Int']['output']>;
  copHotWater?: Maybe<Scalars['Float']['output']>;
  customerEnabled?: Maybe<Scalars['Boolean']['output']>;
  datasheetUrl?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Float']['output']>;
  descriptionId?: Maybe<Scalars['Int']['output']>;
  effect7: CompositeFigure;
  effect12: CompositeFigure;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  energyLabel: CompositeLabel;
  id: Scalars['Float']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  noiseLevel: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  offerID?: Maybe<Scalars['Float']['output']>;
  preferred?: Maybe<Scalars['Boolean']['output']>;
  price: Scalars['Float']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  scop: CompositeFigure;
  size: HeatPumpSize;
  temperatureOut: Scalars['Int']['output'];
  waterLabel: Scalars['String']['output'];
  webshopEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type HeatPumpOutdoorUnitInput = {
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String']['input'];
  buyPrice?: InputMaybe<Scalars['Float']['input']>;
  compatibleIndoorUnits: Array<Scalars['Int']['input']>;
  copHotWater: Scalars['Float']['input'];
  customerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Float']['input']>;
  descriptionId?: InputMaybe<Scalars['Int']['input']>;
  effectFloor7: Scalars['Float']['input'];
  effectFloor12: Scalars['Float']['input'];
  effectRadiator7: Scalars['Float']['input'];
  effectRadiator12: Scalars['Float']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  energyLabelFloor: Scalars['String']['input'];
  energyLabelRadiator: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  model: Scalars['String']['input'];
  noiseLevel: Scalars['Float']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
  price: Scalars['Float']['input'];
  scopFloor: Scalars['Float']['input'];
  scopRadiator: Scalars['Float']['input'];
  temperatureOut: Scalars['Int']['input'];
  waterLabel: Scalars['String']['input'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeatPumpPackageInput = {
  calculatorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  indoorUnitID?: InputMaybe<Scalars['Int']['input']>;
  outdoorUnitID: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeatPumpProductPackage = {
  calculatorEnabled?: Maybe<Scalars['Boolean']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  indoorUnits?: Maybe<Array<HeatPumpIndoorUnit>>;
  outdoorUnits: Array<HeatPumpOutdoorUnit>;
  packageID: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  webshopEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type HeatPumpSize = BoxSize | CylinderSize;

export type HeatingPriority =
  | 'primary'
  | 'secondary';

export type HeatingSource =
  | 'districtHeating'
  | 'electricity'
  | 'gas'
  | 'heatPump'
  | 'oil'
  | 'other';

export type HouseInput = {
  annualPrice: Scalars['Float']['input'];
  fuelType: FuelType;
};

export type HouseInputWithUsage = {
  annualUsage: Scalars['Float']['input'];
  electricCar?: InputMaybe<ElectricCarInput>;
  energyExpenditure?: InputMaybe<Scalars['Float']['input']>;
  fuelType: FuelType;
};

export type Image = {
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  residenceID?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export type IndoorUnitSolutionType =
  | 'mono'
  | 'split';

export type InterestedInAdvice =
  | 'no'
  | 'yes';

export type Inverter = {
  brand: Scalars['String']['output'];
  buyPrice?: Maybe<Scalars['Float']['output']>;
  capacity: Scalars['Float']['output'];
  compatibleBatteries?: Maybe<Array<Scalars['Int']['output']>>;
  customerEnabled?: Maybe<Scalars['Boolean']['output']>;
  datasheetUrl?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Float']['output']>;
  descriptionId?: Maybe<Scalars['Int']['output']>;
  efficiency: Scalars['Float']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  offerID?: Maybe<Scalars['Float']['output']>;
  preferred?: Maybe<Scalars['Boolean']['output']>;
  price: Scalars['Float']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  size: HeatPumpSize;
  warrantyYears: Scalars['Int']['output'];
  webshopEnabled?: Maybe<Scalars['Boolean']['output']>;
  weight: Scalars['Float']['output'];
};

export type InverterInput = {
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String']['input'];
  buyPrice?: InputMaybe<Scalars['Float']['input']>;
  capacity: Scalars['Float']['input'];
  compatibleBatteries?: InputMaybe<Array<Scalars['Int']['input']>>;
  customerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Float']['input']>;
  descriptionId?: InputMaybe<Scalars['Int']['input']>;
  efficiency: Scalars['Float']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  model: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
  price: Scalars['Float']['input'];
  warrantyYears: Scalars['Int']['input'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  weight: Scalars['Float']['input'];
};

export type InvestmentTime =
  | 'laterThan3Months'
  | 'undecided'
  | 'within3Months';

export type LeadProductTypeEnum =
  | 'heatPump'
  | 'other'
  | 'solar';

export type LoginResult = {
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
};

export type MonthlyConsumption = {
  profileKey: MonthlyConsumptionProfile;
  profileValue: Array<Scalars['Float']['output']>;
};

export type MonthlyConsumptionProfile =
  | 'industrial'
  | 'privateDomicile';

export type Mutation = {
  addCustomerLead: Scalars['Boolean']['output'];
  archiveOffer: Scalars['Boolean']['output'];
  callMe: Scalars['Boolean']['output'];
  contactMe: Scalars['Boolean']['output'];
  copyOffer: Offer;
  createBatteryRange: BatteryProductRange;
  createConstant: Constant;
  createHeatPumpPackage: HeatPumpProductPackage;
  createProductDescription: ProductDescription;
  createSolarProductPackage?: Maybe<SolarProductPackage>;
  deleteAssortedProductDatasheet: Scalars['Boolean']['output'];
  deleteBatteryDatasheet: Scalars['Boolean']['output'];
  deleteBatteryRange: Scalars['Boolean']['output'];
  deleteElectricCar: Scalars['Boolean']['output'];
  deleteExpenseTemplate: Scalars['Boolean']['output'];
  deleteHeatPumpIndoorUnitDatasheet: Scalars['Boolean']['output'];
  deleteHeatPumpOutdoorUnitDatasheet: Scalars['Boolean']['output'];
  deleteHeatPumpPackage: Scalars['Boolean']['output'];
  deleteInverterDatasheet: Scalars['Boolean']['output'];
  deleteOfferExpenses: Scalars['Boolean']['output'];
  deleteProductDescription: Scalars['Boolean']['output'];
  deleteResidenceImage: Scalars['Boolean']['output'];
  deleteSiteVisitFile: Scalars['Boolean']['output'];
  deleteSolarPanelDatasheet: Scalars['Boolean']['output'];
  deleteSolarProductPackage: Scalars['Boolean']['output'];
  forgotPassword: Scalars['String']['output'];
  hardDeleteCustomer: Scalars['Boolean']['output'];
  insertAndSendOffers: Scalars['Boolean']['output'];
  insertAndSendOffersExternal: Scalars['Boolean']['output'];
  insertAssortedProduct?: Maybe<AssortedProduct>;
  insertBattery?: Maybe<Battery>;
  insertHeatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  insertHeatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  insertInverter?: Maybe<Inverter>;
  insertOffers: Array<Offer>;
  insertSolarPanel?: Maybe<SolarPanel>;
  login: LoginResult;
  logout: Scalars['Boolean']['output'];
  markOfferAsSent: Scalars['Boolean']['output'];
  refreshLogin: LoginResult;
  regeneratePreview: Scalars['String']['output'];
  register: User;
  registerLead: Scalars['Boolean']['output'];
  removeConstant: Scalars['Boolean']['output'];
  resendVerificationEmail: Scalars['String']['output'];
  setOfferExpenses: Array<OfferExpense>;
  setResidenceRoofType: Scalars['Boolean']['output'];
  syncContactInformationWithCRM: Scalars['Boolean']['output'];
  syncOfferExpenses: Offer;
  syncOfferInformationWithCRM: Scalars['Boolean']['output'];
  syncProductsWithWebshop: Scalars['Boolean']['output'];
  unarchiveOffer: Scalars['Boolean']['output'];
  unregister: Scalars['Boolean']['output'];
  updateAssortedProduct?: Maybe<AssortedProduct>;
  updateAssortedProductImage: Scalars['String']['output'];
  updateBattery?: Maybe<Battery>;
  updateBatteryImage: Scalars['String']['output'];
  updateBatteryRange: BatteryProductRange;
  updateConstant: Constant;
  updateContactScoringFields?: Maybe<Scalars['Boolean']['output']>;
  updateHeatPumpIndoorImage: Scalars['String']['output'];
  updateHeatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  updateHeatPumpOutdoorImage: Scalars['String']['output'];
  updateHeatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  updateHeatPumpPackage: HeatPumpProductPackage;
  updateInverter?: Maybe<Inverter>;
  updateInverterImage: Scalars['String']['output'];
  updateOfferNotes: Offer;
  updateOfferProductPrice: Offer;
  updatePassword: Scalars['Boolean']['output'];
  updateProductDescription: ProductDescription;
  updateSolarPanel?: Maybe<SolarPanel>;
  updateSolarPanelImage: Scalars['String']['output'];
  updateSolarProductPackage?: Maybe<SolarProductPackage>;
  updateUser?: Maybe<User>;
  uploadAssortedProductDatasheet: Scalars['Boolean']['output'];
  uploadBatteryDatasheet: Scalars['Boolean']['output'];
  uploadHeatPumpIndoorUnitDatasheet: Scalars['Boolean']['output'];
  uploadHeatPumpOutdoorUnitDatasheet: Scalars['Boolean']['output'];
  uploadInverterDatasheet: Scalars['Boolean']['output'];
  uploadPublicFile: Scalars['String']['output'];
  uploadResidenceImages: Array<Image>;
  uploadSiteVisitFile: Scalars['String']['output'];
  uploadSolarPanelDatasheet: Scalars['Boolean']['output'];
  upsertCustomer: Customer;
  upsertExpenseTemplate: OfferExpenseTemplate;
  upsertReservation: Offer;
  upsertResidence: Residence;
  upsertSiteVisitAnswerList: Scalars['Boolean']['output'];
};


export type MutationAddCustomerLeadArgs = {
  customer: BankCustomerLead;
};


export type MutationArchiveOfferArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCallMeArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  leadOrigin?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationContactMeArgs = {
  email: Scalars['String']['input'];
  inquiry?: InputMaybe<Scalars['String']['input']>;
  isCompany?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCopyOfferArgs = {
  archiveExisting?: InputMaybe<Scalars['Boolean']['input']>;
  existingOfferID: Scalars['Int']['input'];
  offer: OfferInput;
};


export type MutationCreateBatteryRangeArgs = {
  batteryRangeInput: BatteryRangeInput;
};


export type MutationCreateConstantArgs = {
  constant: ConstantInput;
};


export type MutationCreateHeatPumpPackageArgs = {
  heatPumpPackageInput?: InputMaybe<HeatPumpPackageInput>;
};


export type MutationCreateProductDescriptionArgs = {
  description: ProductDescriptionInput;
};


export type MutationCreateSolarProductPackageArgs = {
  solarPackageInput?: InputMaybe<SolarProductPackageInput>;
};


export type MutationDeleteAssortedProductDatasheetArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteBatteryDatasheetArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteBatteryRangeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteElectricCarArgs = {
  residenceID: Scalars['Int']['input'];
};


export type MutationDeleteExpenseTemplateArgs = {
  templateID: Scalars['Int']['input'];
};


export type MutationDeleteHeatPumpIndoorUnitDatasheetArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteHeatPumpOutdoorUnitDatasheetArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteHeatPumpPackageArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInverterDatasheetArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteOfferExpensesArgs = {
  expenseIds: Array<Scalars['Int']['input']>;
  offerId: Scalars['Int']['input'];
};


export type MutationDeleteProductDescriptionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteResidenceImageArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
  residenceID: Scalars['Int']['input'];
};


export type MutationDeleteSiteVisitFileArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationDeleteSolarPanelDatasheetArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteSolarProductPackageArgs = {
  id: Scalars['Int']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationHardDeleteCustomerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationInsertAndSendOffersArgs = {
  address: AddressInput;
  customer: CustomerInput;
  dataConsent?: InputMaybe<DataConsentInput>;
  heatPumpOffers?: InputMaybe<Array<HeatPumpOfferInput>>;
  residence: ResidenceInput;
  solarOffers?: InputMaybe<Array<SolarOfferInput>>;
};


export type MutationInsertAndSendOffersExternalArgs = {
  address: AddressInput;
  customer: PartnerCustomerInput;
  dataConsent?: InputMaybe<DataConsentInput>;
  heatPumpOffers?: InputMaybe<Array<HeatPumpOfferInput>>;
  residence: PartnerResidenceInput;
  solarOffers?: InputMaybe<Array<SolarOfferInput>>;
};


export type MutationInsertAssortedProductArgs = {
  unit: AssortedProductInput;
};


export type MutationInsertBatteryArgs = {
  unit: BatteryInput;
};


export type MutationInsertHeatPumpIndoorUnitArgs = {
  unit: HeatPumpIndoorUnitInput;
};


export type MutationInsertHeatPumpOutdoorUnitArgs = {
  unit: HeatPumpOutdoorUnitInput;
};


export type MutationInsertInverterArgs = {
  unit: InverterInput;
};


export type MutationInsertOffersArgs = {
  address?: InputMaybe<AddressInput>;
  assortedOffers?: InputMaybe<Array<AssortedOfferInput>>;
  customerID?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  heatPumpOffers?: InputMaybe<Array<HeatPumpOfferInput>>;
  residenceID?: InputMaybe<Scalars['Int']['input']>;
  solarOffers?: InputMaybe<Array<SolarOfferInput>>;
};


export type MutationInsertSolarPanelArgs = {
  unit: SolarPanelInput;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLogoutArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationMarkOfferAsSentArgs = {
  offerID: Scalars['Int']['input'];
  type: OfferPdfTypeEnum;
};


export type MutationRefreshLoginArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRegeneratePreviewArgs = {
  offerID: Scalars['Int']['input'];
  type: OfferPdfTypeEnum;
};


export type MutationRegisterArgs = {
  user: RegisterUserInput;
};


export type MutationRegisterLeadArgs = {
  address: AddressInput;
  customer: CustomerInput;
};


export type MutationRemoveConstantArgs = {
  code: Scalars['String']['input'];
};


export type MutationSetOfferExpensesArgs = {
  expenses: Array<OfferExpenseInput>;
  offerID: Scalars['Int']['input'];
};


export type MutationSetResidenceRoofTypeArgs = {
  residenceId: Scalars['Int']['input'];
  roofType: RoofType;
};


export type MutationSyncContactInformationWithCrmArgs = {
  residenceId: Scalars['Int']['input'];
};


export type MutationSyncOfferExpensesArgs = {
  offerID: Scalars['Int']['input'];
};


export type MutationSyncOfferInformationWithCrmArgs = {
  offerId: Scalars['Int']['input'];
};


export type MutationUnarchiveOfferArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUnregisterArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUpdateAssortedProductArgs = {
  id: Scalars['Int']['input'];
  unit: AssortedProductInput;
};


export type MutationUpdateAssortedProductImageArgs = {
  id: Scalars['Int']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationUpdateBatteryArgs = {
  id: Scalars['Int']['input'];
  unit: BatteryInput;
};


export type MutationUpdateBatteryImageArgs = {
  id: Scalars['Int']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationUpdateBatteryRangeArgs = {
  batteryRangeInput: BatteryRangeInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateConstantArgs = {
  constant: ConstantInput;
};


export type MutationUpdateContactScoringFieldsArgs = {
  email: Scalars['String']['input'];
  scoringFields: ScoringFields;
};


export type MutationUpdateHeatPumpIndoorImageArgs = {
  id: Scalars['Int']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationUpdateHeatPumpIndoorUnitArgs = {
  id: Scalars['Int']['input'];
  unit: HeatPumpIndoorUnitInput;
};


export type MutationUpdateHeatPumpOutdoorImageArgs = {
  id: Scalars['Int']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationUpdateHeatPumpOutdoorUnitArgs = {
  id: Scalars['Int']['input'];
  unit: HeatPumpOutdoorUnitInput;
};


export type MutationUpdateHeatPumpPackageArgs = {
  heatPumpPackageInput: HeatPumpPackageInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateInverterArgs = {
  id: Scalars['Int']['input'];
  unit: InverterInput;
};


export type MutationUpdateInverterImageArgs = {
  id: Scalars['Int']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationUpdateOfferNotesArgs = {
  notes: Scalars['String']['input'];
  offerID: Scalars['Int']['input'];
};


export type MutationUpdateOfferProductPriceArgs = {
  offerID: Scalars['Int']['input'];
  price: Scalars['Float']['input'];
  type: OfferProductType;
  unitID: Scalars['Int']['input'];
};


export type MutationUpdatePasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationUpdateProductDescriptionArgs = {
  description: ProductDescriptionInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateSolarPanelArgs = {
  id: Scalars['Int']['input'];
  unit: SolarPanelInput;
};


export type MutationUpdateSolarPanelImageArgs = {
  id: Scalars['Int']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationUpdateSolarProductPackageArgs = {
  id: Scalars['Int']['input'];
  solarPackageInput: SolarProductPackageInput;
};


export type MutationUpdateUserArgs = {
  user: UpdateUserInput;
};


export type MutationUploadAssortedProductDatasheetArgs = {
  datasheet: Scalars['Upload']['input'];
  id: Scalars['Int']['input'];
};


export type MutationUploadBatteryDatasheetArgs = {
  datasheet: Scalars['Upload']['input'];
  id: Scalars['Int']['input'];
};


export type MutationUploadHeatPumpIndoorUnitDatasheetArgs = {
  datasheet: Scalars['Upload']['input'];
  id: Scalars['Int']['input'];
};


export type MutationUploadHeatPumpOutdoorUnitDatasheetArgs = {
  datasheet: Scalars['Upload']['input'];
  id: Scalars['Int']['input'];
};


export type MutationUploadInverterDatasheetArgs = {
  datasheet: Scalars['Upload']['input'];
  id: Scalars['Int']['input'];
};


export type MutationUploadPublicFileArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadResidenceImagesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  images: Array<Scalars['Upload']['input']>;
};


export type MutationUploadSiteVisitFileArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  offerID: Scalars['Int']['input'];
};


export type MutationUploadSolarPanelDatasheetArgs = {
  datasheet: Scalars['Upload']['input'];
  id: Scalars['Int']['input'];
};


export type MutationUpsertCustomerArgs = {
  customer: CustomerInput;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpsertExpenseTemplateArgs = {
  template: OfferExpenseTemplateInput;
};


export type MutationUpsertReservationArgs = {
  offerID: Scalars['Int']['input'];
  reservation: Scalars['String']['input'];
};


export type MutationUpsertResidenceArgs = {
  customerID?: InputMaybe<Scalars['Int']['input']>;
  customerInput?: InputMaybe<CustomerInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  residence: ResidenceInput;
};


export type MutationUpsertSiteVisitAnswerListArgs = {
  answerList: Array<SiteVisitAnswerInput>;
  code?: InputMaybe<Scalars['String']['input']>;
};

export type NewOfferExpenses = {
  heatPump: Array<OfferExpenseTemplate>;
  solar: Array<OfferExpenseTemplate>;
};

export type Offer = {
  address?: Maybe<Address>;
  assortedProducts?: Maybe<Array<AssortedProduct>>;
  battery?: Maybe<Battery>;
  batteryProduct?: Maybe<Product>;
  chosenHeating?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Float']['output']>;
  customer?: Maybe<Customer>;
  deletedAt?: Maybe<Scalars['Float']['output']>;
  expenses?: Maybe<Array<OfferExpense>>;
  finalPreview: Scalars['String']['output'];
  heatPumpIndoorProduct?: Maybe<Product>;
  heatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  heatPumpOutdoorProduct?: Maybe<Product>;
  heatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  id: Scalars['Int']['output'];
  installationAccessCode: Scalars['String']['output'];
  inverter?: Maybe<Inverter>;
  inverterProduct?: Maybe<Product>;
  notes?: Maybe<Scalars['String']['output']>;
  preferred?: Maybe<Scalars['Boolean']['output']>;
  preliminaryPreview: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  reservations?: Maybe<Scalars['String']['output']>;
  residence?: Maybe<Residence>;
  residenceID: Scalars['Int']['output'];
  sentOffers?: Maybe<Array<OfferDispatch>>;
  siteVisitAccessCode: Scalars['String']['output'];
  solarPanel?: Maybe<SolarPanel>;
  solarPanelProduct?: Maybe<Product>;
  tag: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Float']['output']>;
};

export type OfferActor =
  | 'advisor'
  | 'customer';

export type OfferDispatch = {
  id: Scalars['Int']['output'];
  sentAt?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<OfferPdfTypeEnum>;
};

export type OfferExpense = {
  buyPrice: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  includedByDefault?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  offerID: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  templateID?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OfferExpenseType>;
};

export type OfferExpenseInput = {
  buyPrice: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  templateID?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OfferExpenseType>;
};

export type OfferExpenseTemplate = {
  automations?: Maybe<Array<ExpenseAutomation>>;
  buyPrice: Scalars['Float']['output'];
  createdAt: Scalars['Float']['output'];
  denominator?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  includedByDefault?: Maybe<Scalars['Boolean']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  minimumProducts?: Maybe<Scalars['Int']['output']>;
  offerType?: Maybe<OfferType>;
  price: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  type: OfferExpenseTemplateType;
  updatedAt?: Maybe<Scalars['Float']['output']>;
};

export type OfferExpenseTemplateInput = {
  automations?: InputMaybe<Array<ExpenseAutomationInput>>;
  buyPrice: Scalars['Float']['input'];
  denominator?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includedByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  offerType: OfferType;
  price: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  type: OfferExpenseTemplateType;
};

export type OfferExpenseTemplateType =
  | 'batteryInstallation'
  | 'indoorUnitInstallation'
  | 'inverterInstallation'
  | 'nonPhysical'
  | 'outdoorUnitInstallation'
  | 'physical'
  | 'solarPanelInstallation';

export type OfferExpenseType =
  | 'installation'
  | 'nonPhysical'
  | 'physical';

export type OfferInput = {
  assortedProducts?: InputMaybe<Array<ProductInput>>;
  batteryProduct?: InputMaybe<ProductInput>;
  chosenHeating?: InputMaybe<Scalars['Float']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Int']['input']>;
  expenses?: InputMaybe<Array<OfferExpenseInput>>;
  heatPumpIndoorProduct?: InputMaybe<ProductInput>;
  heatPumpOutdoorProduct?: InputMaybe<ProductInput>;
  inverterProduct?: InputMaybe<ProductInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reservations?: InputMaybe<Scalars['String']['input']>;
  solarPanelProduct?: InputMaybe<ProductInput>;
  withoutInstallation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OfferPdfTypeEnum =
  | 'final'
  | 'preliminary';

export type OfferProductType =
  | 'assorted'
  | 'battery'
  | 'heatPumpIndoorUnit'
  | 'heatPumpOutdoorUnit'
  | 'inverter'
  | 'solarPanel';

export type OfferProducts = {
  battery?: Maybe<Battery>;
  expenses?: Maybe<Array<OfferExpense>>;
  heatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  heatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  inverter?: Maybe<Inverter>;
  price?: Maybe<Scalars['Float']['output']>;
  solarPackageDiscount?: Maybe<Scalars['Int']['output']>;
  solarPackageId?: Maybe<Scalars['Int']['output']>;
  solarPanel?: Maybe<SolarPanel>;
};

export type OfferSavings = {
  after: ProductUsage;
  before: ProductUsage;
  saved: OfferTotalSaved;
};

export type OfferSavingsWithProducts = {
  disclaimer: Scalars['String']['output'];
  investment: Scalars['Float']['output'];
  paybackMonths: Scalars['Float']['output'];
  products: OfferProducts;
  residence?: Maybe<SimpleResidenceResult>;
  savings: OfferSavings;
  types: Array<OfferType>;
};

export type OfferTotalSaved = {
  emission: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  priceByYear: Array<Scalars['Float']['output']>;
};

export type OfferType =
  | 'assorted'
  | 'heatPump'
  | 'solar';

export type OffersWithCount = {
  count: Scalars['Int']['output'];
  offers: Array<Offer>;
};

export type PanelCategory =
  | 'builtIn'
  | 'freeStanding';

export type PanelType =
  | 'monoCrystal'
  | 'polyCrystal';

export type PartialHouseInput = {
  annualElectricityPrice?: InputMaybe<Scalars['Float']['input']>;
  annualHeatingPrice?: InputMaybe<Scalars['Float']['input']>;
  fuelType?: InputMaybe<FuelType>;
};

export type PartialResidenceInput = {
  addressID?: InputMaybe<Scalars['Float']['input']>;
  area?: InputMaybe<Scalars['Float']['input']>;
  areaHeated?: InputMaybe<Scalars['Float']['input']>;
  areaNotHeated?: InputMaybe<Scalars['Float']['input']>;
  areaPartiallyHeated?: InputMaybe<Scalars['Float']['input']>;
  customerID?: InputMaybe<Scalars['Float']['input']>;
  electricCar?: InputMaybe<ElectricCarInput>;
  energyExpenditure?: InputMaybe<Scalars['Float']['input']>;
  energyLabel?: InputMaybe<EnergyLabelEnum>;
  heatDistribution?: InputMaybe<HeatDistributionTypeEnum>;
  primaryHeating?: InputMaybe<ResidenceHeatingInput>;
  radiatorFloorPercentage?: InputMaybe<Scalars['Float']['input']>;
  roofs?: InputMaybe<Array<RoofInput>>;
  secondaryHeating?: InputMaybe<ResidenceHeatingInput>;
  type?: InputMaybe<ResidenceType>;
};

export type PartnerCustomerInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leadOrigin: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerResidenceInput = {
  annualElectricityPrice: Scalars['Float']['input'];
  annualHeatingPrice: Scalars['Float']['input'];
  fuelType: FuelType;
};

export type Product = {
  id: Scalars['Int']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type ProductDescription = {
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: OfferProductType;
};

export type ProductDescriptionInput = {
  content: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: OfferProductType;
};

export type ProductInput = {
  buyPrice?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductUsage = {
  bought: Scalars['Float']['output'];
  boughtPrice?: Maybe<Scalars['Float']['output']>;
  consumptionPerMonth?: Maybe<Array<Scalars['Float']['output']>>;
  domesticDiscount: Scalars['Float']['output'];
  domesticPrice: Scalars['Float']['output'];
  electricityDiscount?: Maybe<Scalars['Float']['output']>;
  fuelPrice?: Maybe<Scalars['Float']['output']>;
  netEarning?: Maybe<Scalars['Float']['output']>;
  netSpentElectricity?: Maybe<Scalars['Float']['output']>;
  produced: Scalars['Float']['output'];
  productionPerMonth?: Maybe<Array<Scalars['Float']['output']>>;
  sold: Scalars['Float']['output'];
  soldPrice?: Maybe<Scalars['Float']['output']>;
  totalEmission?: Maybe<Scalars['Float']['output']>;
  totalPrice: Scalars['Float']['output'];
  used: Scalars['Float']['output'];
  usedPercentage?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  addressSavings: AllOfferSavings;
  allOfferTypeSavings: Array<OfferSavingsWithProducts>;
  assortedProduct?: Maybe<AssortedProduct>;
  assortedProductBrands: Array<Scalars['String']['output']>;
  assortedProducts: Array<AssortedProduct>;
  batteries: Array<Battery>;
  battery?: Maybe<Battery>;
  batteryBrands: Array<Scalars['String']['output']>;
  batteryRanges: Array<BatteryProductRange>;
  bbrLookupByAddress?: Maybe<BbrResidence>;
  bbrLookupByDawaId?: Maybe<BbrResidence>;
  bodilAdvisors: Array<User>;
  calculateAddressSavings: AllOfferSavings;
  calculateAddressSavingsLokalBolig: AllOfferSavings;
  calculateAddressSavingsPartialResidenceEDC: AllOfferSavings;
  calculateEnergyLabels: EnergyLabels;
  calculateOfferSavings: OfferSavings;
  calculateOfferTypeSavings: OfferSavingsWithProducts;
  constants: Array<Constant>;
  constantsWithPartialCode: Array<Constant>;
  crmCustomerFieldValues?: Maybe<CrmCustomerFields>;
  customer?: Maybe<Customer>;
  dashboardOffers: OffersWithCount;
  energyLabel?: Maybe<EnergyLabelEnum>;
  energyOptions: Array<Constant>;
  expenseTemplates: Array<OfferExpenseTemplate>;
  heatPumpBrands: Array<Scalars['String']['output']>;
  heatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  heatPumpIndoorUnits: Array<HeatPumpIndoorUnit>;
  heatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  heatPumpOutdoorUnits: Array<HeatPumpOutdoorUnit>;
  heatPumpPackages: Array<HeatPumpProductPackage>;
  inverter?: Maybe<Inverter>;
  inverterBrands: Array<Scalars['String']['output']>;
  inverters: Array<Inverter>;
  me: User;
  newOfferExpenses: NewOfferExpenses;
  offer?: Maybe<Offer>;
  offerByCode?: Maybe<Offer>;
  offerByTag?: Maybe<Offer>;
  offerSavings: OfferSavings;
  offerTypeSavings: OfferSavingsWithProducts;
  offers?: Maybe<Array<Offer>>;
  productDescriptions: Array<ProductDescription>;
  recommendedSolarPackage: SolarProductPackage;
  residence?: Maybe<Residence>;
  residences?: Maybe<Array<Residence>>;
  residencesBySearch: Array<Residence>;
  searchCRMCustomers?: Maybe<Array<CrmCustomer>>;
  searchCustomers?: Maybe<Array<Customer>>;
  searchCustomersByEmail?: Maybe<Array<Customer>>;
  siteVisitAnswerList: Array<SiteVisitAnswer>;
  siteVisitFiles: Array<SiteVisitFile>;
  solarPackageSavings: Array<SolarPackageSavings>;
  solarPanel?: Maybe<SolarPanel>;
  solarPanelBrands: Array<Scalars['String']['output']>;
  solarPanels: Array<SolarPanel>;
  solarProductPackages: Array<SolarProductPackage>;
  user?: Maybe<User>;
};


export type QueryAddressSavingsArgs = {
  dawaId: Scalars['String']['input'];
  isAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  residence?: InputMaybe<HouseInputWithUsage>;
};


export type QueryAllOfferTypeSavingsArgs = {
  address: AddressInput;
  chosenHeating?: InputMaybe<Scalars['Float']['input']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']['input']>>;
  customerID?: InputMaybe<Scalars['Float']['input']>;
  isAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  residence?: InputMaybe<PartialResidenceInput>;
  types: Array<OfferType>;
};


export type QueryAssortedProductArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssortedProductsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryBatteriesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBatteryArgs = {
  id: Scalars['Int']['input'];
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBatteryRangesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryBbrLookupByAddressArgs = {
  address: AddressInput;
};


export type QueryBbrLookupByDawaIdArgs = {
  dawaId: Scalars['String']['input'];
};


export type QueryCalculateAddressSavingsArgs = {
  dawaId: Scalars['String']['input'];
  residence?: InputMaybe<HouseInput>;
};


export type QueryCalculateAddressSavingsLokalBoligArgs = {
  dawaId: Scalars['String']['input'];
  residence?: InputMaybe<HouseInput>;
};


export type QueryCalculateAddressSavingsPartialResidenceEdcArgs = {
  dawaId: Scalars['String']['input'];
  residence?: InputMaybe<PartialHouseInput>;
};


export type QueryCalculateEnergyLabelsArgs = {
  address: AddressInput;
  residence?: InputMaybe<PartialResidenceInput>;
};


export type QueryCalculateOfferSavingsArgs = {
  address: AddressInput;
  chosenHeating?: InputMaybe<Scalars['Float']['input']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']['input']>>;
  customerID?: InputMaybe<Scalars['Float']['input']>;
  offer: OfferInput;
  residence?: InputMaybe<PartialResidenceInput>;
};


export type QueryCalculateOfferTypeSavingsArgs = {
  address: AddressInput;
  chosenHeating?: InputMaybe<Scalars['Float']['input']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']['input']>>;
  customerID?: InputMaybe<Scalars['Float']['input']>;
  residence?: InputMaybe<PartialResidenceInput>;
  types: Array<OfferType>;
};


export type QueryConstantsArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryConstantsWithPartialCodeArgs = {
  partialCode: Scalars['String']['input'];
};


export type QueryCrmCustomerFieldValuesArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDashboardOffersArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offerType?: InputMaybe<OfferType>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<SortOrder>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnergyLabelArgs = {
  addressId: Scalars['String']['input'];
};


export type QueryEnergyOptionsArgs = {
  residenceId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExpenseTemplatesArgs = {
  type: OfferType;
};


export type QueryHeatPumpIndoorUnitArgs = {
  id: Scalars['Int']['input'];
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeatPumpIndoorUnitsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeatPumpOutdoorUnitArgs = {
  id: Scalars['Int']['input'];
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeatPumpOutdoorUnitsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeatPumpPackagesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryInverterArgs = {
  id: Scalars['Int']['input'];
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInvertersArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOfferArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOfferByCodeArgs = {
  code: Scalars['String']['input'];
  purpose: TokenPurpose;
};


export type QueryOfferByTagArgs = {
  offerTag: Scalars['String']['input'];
};


export type QueryOfferSavingsArgs = {
  address?: InputMaybe<AddressInput>;
  chosenHeating?: InputMaybe<Scalars['Float']['input']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']['input']>>;
  customerID?: InputMaybe<Scalars['Float']['input']>;
  offer: OfferInput;
  residence: ResidenceInput;
};


export type QueryOfferTypeSavingsArgs = {
  address: AddressInput;
  chosenHeating?: InputMaybe<Scalars['Float']['input']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']['input']>>;
  customerID?: InputMaybe<Scalars['Float']['input']>;
  isAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  residence?: InputMaybe<PartialResidenceInput>;
  types: Array<OfferType>;
};


export type QueryOffersArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  customerID?: InputMaybe<Scalars['Int']['input']>;
  residenceID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductDescriptionsArgs = {
  type: OfferProductType;
};


export type QueryRecommendedSolarPackageArgs = {
  residence: ResidenceInput;
};


export type QueryResidenceArgs = {
  address?: InputMaybe<AddressInput>;
  customerID?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResidencesArgs = {
  address?: InputMaybe<AddressInput>;
  customerID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResidencesBySearchArgs = {
  actor?: InputMaybe<OfferActor>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchCrmCustomersArgs = {
  email: Scalars['String']['input'];
};


export type QuerySearchCustomersArgs = {
  search: Scalars['String']['input'];
};


export type QuerySearchCustomersByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QuerySiteVisitAnswerListArgs = {
  residenceID: Scalars['Int']['input'];
};


export type QuerySiteVisitFilesArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  offerID: Scalars['Int']['input'];
};


export type QuerySolarPackageSavingsArgs = {
  residence: ResidenceInput;
};


export type QuerySolarPanelArgs = {
  id: Scalars['Int']['input'];
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySolarPanelsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySolarProductPackagesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  onlyDefaultBattery?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};

/** register user */
export type RegisterUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type RenovationDegreeEnum =
  | 'asBuilt'
  | 'maximum'
  | 'medium';

export type Residence = {
  address?: Maybe<Address>;
  addressID: Scalars['Int']['output'];
  area: Scalars['Float']['output'];
  areaHeated: Scalars['Float']['output'];
  areaNotHeated?: Maybe<Scalars['Int']['output']>;
  areaPartiallyHeated?: Maybe<Scalars['Float']['output']>;
  builtYear?: Maybe<Scalars['Float']['output']>;
  consumption?: Maybe<Consumption>;
  consumptionProfile?: Maybe<ConsumptionProfile>;
  createdAt: Scalars['Float']['output'];
  customer?: Maybe<Customer>;
  customerID: Scalars['Int']['output'];
  electricCar?: Maybe<ElectricCar>;
  electricityPrice?: Maybe<Scalars['Float']['output']>;
  energyExpenditure: Scalars['Float']['output'];
  energyLabel?: Maybe<EnergyLabelEnum>;
  floors: Scalars['Float']['output'];
  hasExistingSolarPanels?: Maybe<Scalars['Boolean']['output']>;
  heatDistribution: HeatDistributionTypeEnum;
  heatingCircuits?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  images: Array<Image>;
  monthlyConsumption?: Maybe<MonthlyConsumption>;
  monthlyConsumptionProfile?: Maybe<MonthlyConsumptionProfile>;
  noiseWeight: WaterConsumptionDegreeEnum;
  offerProducts?: Maybe<Array<OfferType>>;
  primaryHeating?: Maybe<ResidenceHeating>;
  radiatorFloorPercentage?: Maybe<Scalars['Float']['output']>;
  renovatedDegree?: Maybe<RenovationDegreeEnum>;
  renovatedYear?: Maybe<Scalars['Float']['output']>;
  residents?: Maybe<Scalars['Float']['output']>;
  roofType?: Maybe<RoofType>;
  roofs?: Maybe<Array<Roof>>;
  secondaryHeating?: Maybe<ResidenceHeating>;
  type: ResidenceType;
  updatedAt?: Maybe<Scalars['Float']['output']>;
  waterConsumption: WaterConsumptionDegreeEnum;
};

export type ResidenceHeating = {
  annualUsage: Scalars['Float']['output'];
  efficiency?: Maybe<Scalars['Float']['output']>;
  fuelSubtype?: Maybe<Scalars['String']['output']>;
  fuelType: Scalars['String']['output'];
  heatSource?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  priority: HeatingPriority;
  volumeUnit?: Maybe<Scalars['String']['output']>;
};

export type ResidenceHeatingInput = {
  annualUsage: Scalars['Float']['input'];
  efficiency?: InputMaybe<Scalars['Float']['input']>;
  fuelSubtype?: InputMaybe<Scalars['String']['input']>;
  fuelType: Scalars['String']['input'];
  heatSource?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<HeatingPriority>;
  volumeUnit?: InputMaybe<Scalars['String']['input']>;
};

export type ResidenceInput = {
  address?: InputMaybe<AddressInput>;
  addressID?: InputMaybe<Scalars['Int']['input']>;
  area: Scalars['Float']['input'];
  areaHeated: Scalars['Float']['input'];
  areaNotHeated?: InputMaybe<Scalars['Int']['input']>;
  areaPartiallyHeated?: InputMaybe<Scalars['Float']['input']>;
  builtYear?: InputMaybe<Scalars['Float']['input']>;
  consumptionProfile?: InputMaybe<ConsumptionProfile>;
  customerID?: InputMaybe<Scalars['Int']['input']>;
  electricCar?: InputMaybe<ElectricCarInput>;
  electricityPrice?: InputMaybe<Scalars['Float']['input']>;
  energyExpenditure: Scalars['Float']['input'];
  energyLabel?: InputMaybe<EnergyLabelEnum>;
  floors: Scalars['Int']['input'];
  hasExistingSolarPanels?: InputMaybe<Scalars['Boolean']['input']>;
  heatDistribution: HeatDistributionTypeEnum;
  heatingCircuits?: InputMaybe<Scalars['Int']['input']>;
  monthlyConsumptionProfile?: InputMaybe<MonthlyConsumptionProfile>;
  noiseWeight?: InputMaybe<WaterConsumptionDegreeEnum>;
  primaryHeating: ResidenceHeatingInput;
  radiatorFloorPercentage?: InputMaybe<Scalars['Float']['input']>;
  renovatedDegree?: InputMaybe<RenovationDegreeEnum>;
  renovatedYear?: InputMaybe<Scalars['Float']['input']>;
  residents?: InputMaybe<Scalars['Float']['input']>;
  roofType?: InputMaybe<RoofType>;
  roofs?: InputMaybe<Array<RoofInput>>;
  secondaryHeating?: InputMaybe<ResidenceHeatingInput>;
  type: ResidenceType;
  waterConsumption: WaterConsumptionDegreeEnum;
};

export type ResidenceOwnership =
  | 'lookingToBuy'
  | 'owner'
  | 'renting';

export type ResidenceType =
  | 'apartment'
  | 'summerhouse'
  | 'townhouse'
  | 'villa';

export type Roof = {
  height?: Maybe<Scalars['Float']['output']>;
  isGuessed?: Maybe<Scalars['Boolean']['output']>;
  maxPanelCoverage?: Maybe<Scalars['Float']['output']>;
  orientation: Scalars['Float']['output'];
  planeDepth: Scalars['Float']['output'];
  planeWidth: Scalars['Float']['output'];
  shadows?: Maybe<RoofShadows>;
};

export type RoofInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  isGuessed?: InputMaybe<Scalars['Boolean']['input']>;
  maxPanelCoverage?: InputMaybe<Scalars['Float']['input']>;
  orientation: Scalars['Int']['input'];
  planeDepth: Scalars['Int']['input'];
  planeWidth: Scalars['Int']['input'];
  shadows?: InputMaybe<RoofShadows>;
};

export type RoofShadows =
  | 'many'
  | 'none'
  | 'some';

export type RoofType =
  | 'clayTile'
  | 'concreteTile'
  | 'felt'
  | 'fiberCement'
  | 'flat'
  | 'metal'
  | 'other'
  | 'unknown';

export type ScoringFields = {
  heatingSource?: InputMaybe<HeatingSource>;
  interestedInAdvice?: InputMaybe<InterestedInAdvice>;
  investmentTime?: InputMaybe<InvestmentTime>;
  referencedBy?: InputMaybe<SourceOfReference>;
  residenceOwnership?: InputMaybe<ResidenceOwnership>;
  yearlyElectricityCost?: InputMaybe<YearlyElectricityCost>;
  yearlyHeatingCost?: InputMaybe<YearlyHeatingCost>;
};

export type SimpleResidenceResult = {
  annualElectricityPrice: Scalars['Float']['output'];
  annualHeatingPrice: Scalars['Float']['output'];
  existingSolarArrayEffect?: Maybe<Scalars['Float']['output']>;
  fuelType: FuelType;
};

export type SiteVisitAnswer = {
  answer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  question?: Maybe<SiteVisitQuestion>;
  residenceId: Scalars['Int']['output'];
};

export type SiteVisitAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  question: SiteVisitQuestion;
  residenceId: Scalars['Int']['input'];
};

export type SiteVisitFile = {
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  offerID: Scalars['Float']['output'];
  url: Scalars['String']['output'];
};

export type SiteVisitQuestion =
  | 'atticOrRaisedCelling'
  | 'bufferRequired'
  | 'bufferRequiredSolar'
  | 'bypassValves'
  | 'canFurnaceBeDismantled'
  | 'changeCirculationPump'
  | 'condensationPump'
  | 'correctColdRooms'
  | 'correctConsumption'
  | 'correctConsumptionSecondary'
  | 'correctHeatedArea'
  | 'digDownPipes'
  | 'distanceInOut'
  | 'distanceToInstallation'
  | 'distanceToSolar'
  | 'easyAvailableForScaffolding'
  | 'electricRelayAutoSafetyAndExtra'
  | 'electricRelayWork'
  | 'electricityNotes'
  | 'electricitySolarNotes'
  | 'floorHeatingExtraShunts'
  | 'floorPlanNotes'
  | 'hasUnderRoof'
  | 'heatPumpEntryPossible'
  | 'heatSourceNotes'
  | 'indoorAlternativeNotes'
  | 'indoorPlacementNotes'
  | 'indoorUnitOnFloorPlan'
  | 'installationOnFloorPlan'
  | 'inverterAndBatteryOnFloorPlan'
  | 'inverterAndBatteryPlacementNotes'
  | 'noiseLimitObserved'
  | 'otherNotes'
  | 'outdoorPlacementNotes'
  | 'outdoorUnitOnFloorPlan'
  | 'pipingMaterial'
  | 'pipingNotes'
  | 'pipingOnFloorPlan'
  | 'pipingPlacement'
  | 'providerForFoundation'
  | 'providerForFoundationSolar'
  | 'radiatorPipingSize'
  | 'radiatorsNotes'
  | 'replaceFurnaceWithRadiator'
  | 'replaceRadiators'
  | 'roofConstructionNotes'
  | 'roofType'
  | 'roomForMaterials'
  | 'roomForWaterTank'
  | 'solarCableOnFloorPlan'
  | 'solarEntryPossible'
  | 'solarOnFloorPlan'
  | 'solarPlacementNotes'
  | 'systemStringNumber'
  | 'twoPipingSystems'
  | 'wiringInCeiling'
  | 'wiringInCeilingForSolar';

export type SolarOfferInput = {
  batteryProduct?: InputMaybe<ProductInput>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Int']['input']>;
  expenses?: InputMaybe<Array<OfferExpenseInput>>;
  inverterProduct?: InputMaybe<ProductInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reservations?: InputMaybe<Scalars['String']['input']>;
  solarPanelProduct?: InputMaybe<ProductInput>;
  withoutInstallation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SolarPackageSavings = {
  packageID: Scalars['Int']['output'];
  quantity: Scalars['Float']['output'];
  savings: Scalars['Float']['output'];
  title?: Maybe<Scalars['String']['output']>;
  totalPrice: Scalars['Float']['output'];
  totalSaved: Scalars['Float']['output'];
  usedPercentage: Scalars['Float']['output'];
};

export type SolarPanel = {
  annualProduction: Scalars['Float']['output'];
  brand: Scalars['String']['output'];
  buyPrice?: Maybe<Scalars['Float']['output']>;
  capacity: Scalars['Float']['output'];
  category: PanelCategory;
  compatibleInverters: Array<Scalars['Int']['output']>;
  customerEnabled?: Maybe<Scalars['Boolean']['output']>;
  datasheetUrl?: Maybe<Scalars['String']['output']>;
  degradationPerYear: Scalars['Float']['output'];
  deletedAt?: Maybe<Scalars['Float']['output']>;
  descriptionId?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  offerID?: Maybe<Scalars['Float']['output']>;
  performanceWarrantyYears: Scalars['Int']['output'];
  preferred?: Maybe<Scalars['Boolean']['output']>;
  price: Scalars['Float']['output'];
  productWarrantyYears: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  size: BoxSize;
  type: PanelType;
  webshopEnabled?: Maybe<Scalars['Boolean']['output']>;
  weight: Scalars['Float']['output'];
};

export type SolarPanelInput = {
  annualProduction: Scalars['Float']['input'];
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String']['input'];
  buyPrice?: InputMaybe<Scalars['Float']['input']>;
  capacity: Scalars['Float']['input'];
  category: PanelCategory;
  compatibleInverters: Array<Scalars['Int']['input']>;
  customerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']['input']>;
  degradationPerYear: Scalars['Float']['input'];
  deletedAt?: InputMaybe<Scalars['Float']['input']>;
  descriptionId?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  model: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  performanceWarrantyYears: Scalars['Int']['input'];
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
  price: Scalars['Float']['input'];
  productWarrantyYears: Scalars['Int']['input'];
  type: PanelType;
  webshopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  weight: Scalars['Float']['input'];
};

export type SolarProductPackage = {
  batteries?: Maybe<Array<Battery>>;
  batteryRangeID?: Maybe<Scalars['Int']['output']>;
  calculatorEnabled?: Maybe<Scalars['Boolean']['output']>;
  defaultBatteryID?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discountWithoutInstallation?: Maybe<Scalars['Float']['output']>;
  inverter: Inverter;
  maximumEnergyExpenditure?: Maybe<Scalars['Float']['output']>;
  packageID: Scalars['Int']['output'];
  solarPanel: SolarPanel;
  title?: Maybe<Scalars['String']['output']>;
  webshopEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type SolarProductPackageInput = {
  batteryRangeID?: InputMaybe<Scalars['Int']['input']>;
  calculatorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  defaultBatteryID?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Float']['input']>;
  inverterID: Scalars['Int']['input'];
  solarPanelID: Scalars['Int']['input'];
  solarPanelQuantity: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SortOrder =
  | 'ascending'
  | 'descending';

export type SourceOfReference =
  | 'google'
  | 'meta'
  | 'other'
  | 'partner'
  | 'trustPilot'
  | 'wordOfMouth';

export type TokenPurpose =
  | 'forgotPassword'
  | 'installationAccess'
  | 'refreshToken'
  | 'siteVisitAccess'
  | 'verifyEmail';

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  authProviders?: Maybe<Array<AuthProvider>>;
  createdAt: Scalars['Float']['output'];
  email: Scalars['String']['output'];
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isMe: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileImageID?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Float']['output']>;
};

export type UtmFields = {
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

export type WaterConsumptionDegreeEnum =
  | 'large'
  | 'medium'
  | 'small';

export type YearlyElectricityCost =
  | 'between4000and14000'
  | 'lessThan4000'
  | 'moreThan14000'
  | 'unknown';

export type YearlyHeatingCost =
  | 'between15000and25000'
  | 'lessThan15000'
  | 'moreThan25000'
  | 'unknown';

export type AssortedProductsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type AssortedProductsQuery = { assortedProducts: Array<{ id: number, brand: string, model: string, descriptionId?: number | null, price: number, buyPrice?: number | null, datasheetUrl?: string | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> };

export type RefreshLoginMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshLoginMutation = { refreshLogin: { accessToken: string, refreshToken: string } };

export type LogoutMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type LogoutMutation = { logout: boolean };

export type BatteriesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type BatteriesQuery = { batteries: Array<{ id: number, brand: string, model: string, weight: number, capacity: number, efficiency: number, warrantyYears?: number | null, warrantyCycles?: number | null, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> };

export type BbrLookupByAddressQueryVariables = Exact<{
  address: AddressInput;
}>;


export type BbrLookupByAddressQuery = { bbrLookupByAddress?: { type: ResidenceType, floors: number, residents?: number | null, builtYear?: number | null, renovatedYear?: number | null, renovatedDegree?: RenovationDegreeEnum | null, area: number, areaHeated: number, areaNotHeated?: number | null, energyExpenditure: number, energyLabel?: EnergyLabelEnum | null, primaryHeating?: { heatSource?: string | null, annualUsage: number, price?: number | null, efficiency?: number | null, fuelType: string, fuelSubtype?: string | null, volumeUnit?: string | null } | null, secondaryHeating?: { heatSource?: string | null } | null, roofs?: Array<{ orientation: number, planeWidth: number, planeDepth: number, height?: number | null, maxPanelCoverage?: number | null, shadows?: RoofShadows | null, isGuessed?: boolean | null }> | null } | null };

export type BbrLookupByDawaIdQueryVariables = Exact<{
  dawaId: Scalars['String']['input'];
}>;


export type BbrLookupByDawaIdQuery = { bbrLookupByDawaId?: { type: ResidenceType, floors: number, residents?: number | null, builtYear?: number | null, renovatedYear?: number | null, renovatedDegree?: RenovationDegreeEnum | null, area: number, areaHeated: number, areaNotHeated?: number | null, energyExpenditure: number, energyLabel?: EnergyLabelEnum | null, primaryHeating?: { heatSource?: string | null, annualUsage: number, price?: number | null, efficiency?: number | null, fuelType: string, fuelSubtype?: string | null, volumeUnit?: string | null } | null, secondaryHeating?: { heatSource?: string | null } | null, roofs?: Array<{ orientation: number, planeWidth: number, planeDepth: number, height?: number | null, maxPanelCoverage?: number | null, shadows?: RoofShadows | null, isGuessed?: boolean | null }> | null } | null };

export type SyncContactInformationWithCrmMutationVariables = Exact<{
  residenceId: Scalars['Int']['input'];
}>;


export type SyncContactInformationWithCrmMutation = { syncContactInformationWithCRM: boolean };

export type SearchCrmCustomersQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SearchCrmCustomersQuery = { searchCRMCustomers?: Array<{ email?: string | null, firstName?: string | null, id?: string | null, lastName?: string | null, phoneNumber?: string | null }> | null };

export type CrmCustomerFieldValuesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CrmCustomerFieldValuesQuery = { crmCustomerFieldValues?: { address?: string | null, assignedAdvisor?: string | null, financialAdvisor?: string | null, leadOrigin?: string | null, notes?: string | null } | null };

export type SyncOfferInformationWithCrmMutationVariables = Exact<{
  offerId: Scalars['Int']['input'];
}>;


export type SyncOfferInformationWithCrmMutation = { syncOfferInformationWithCRM: boolean };

export type CustomerQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CustomerQuery = { customer?: { assignedAdvisorId?: number | null, includeHeatPumpSubsidy?: boolean | null, usePriceInflation?: boolean | null, createdAt: number, eligibleForFinancing: boolean, financialAdvisor?: string | null, financingProvider?: CustomerFinancingProvider | null, leadOrigin?: string | null, norlysPromotion?: boolean | null, email?: string | null, firstName?: string | null, lastName?: string | null, id: number, name: string, notes?: string | null, phoneNumber?: string | null, assignedAdvisor?: { firstName: string, lastName: string, email: string, phoneNumber?: string | null } | null } | null };

export type SearchCustomersQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchCustomersQuery = { searchCustomers?: Array<{ assignedAdvisorId?: number | null, financialAdvisor?: string | null, financingProvider?: CustomerFinancingProvider | null, leadOrigin?: string | null, norlysPromotion?: boolean | null, includeHeatPumpSubsidy?: boolean | null, usePriceInflation?: boolean | null, email?: string | null, firstName?: string | null, lastName?: string | null, id: number, name: string, notes?: string | null, phoneNumber?: string | null, assignedAdvisor?: { firstName: string, lastName: string, email: string, phoneNumber?: string | null } | null }> | null };

export type SearchCustomersByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SearchCustomersByEmailQuery = { searchCustomersByEmail?: Array<{ id: number }> | null };

export type UpsertCustomerMutationVariables = Exact<{
  customer: CustomerInput;
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpsertCustomerMutation = { upsertCustomer: { id: number } };

export type EnergyOptionsQueryVariables = Exact<{
  residenceId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EnergyOptionsQuery = { energyOptions: Array<{ code: string, denominator?: string | null, numerator: string, valueNumber: number }> };

export type NewOfferExpensesQueryVariables = Exact<{ [key: string]: never; }>;


export type NewOfferExpensesQuery = { newOfferExpenses: { heatPump: Array<{ title: string, description?: string | null, price: number, buyPrice: number, type: OfferExpenseTemplateType, minimumProducts?: number | null, includedByDefault?: boolean | null }>, solar: Array<{ title: string, description?: string | null, price: number, buyPrice: number, type: OfferExpenseTemplateType, minimumProducts?: number | null, includedByDefault?: boolean | null }> } };

export type AddressFragment = { city: string, door?: string | null, floor?: string | null, houseNumber: string, postalCode: string, street: string };

export type BoxSizeFragment = { height: number, width: number, depth: number };

export type CompositeFigureFragment = { floor: number, radiator: number };

export type CylinderSizeFragment = { height: number, diameter: number };

export type CustomerFragment = { email?: string | null, firstName?: string | null, lastName?: string | null, id: number, name: string, notes?: string | null, phoneNumber?: string | null, assignedAdvisor?: { firstName: string, lastName: string, email: string, phoneNumber?: string | null } | null };

export type OfferExpenseFragment = { description?: string | null, id: number, notes?: string | null, offerID: number, price: number, buyPrice: number, quantity: number, templateID?: number | null, title?: string | null, type?: OfferExpenseType | null, includedByDefault?: boolean | null };

export type HeatPumpOutdoorUnitFragment = { id: number, datasheetUrl?: string | null, brand: string, model: string, compatibleIndoorUnits: Array<number>, noiseLevel: number, temperatureOut: number, waterLabel: string, copHotWater?: number | null, imageUrl?: string | null, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, notes?: string | null, scop: { floor: number, radiator: number }, energyLabel: { floor: string, radiator: string }, effect7: { floor: number, radiator: number }, effect12: { floor: number, radiator: number }, size: { height: number, width: number, depth: number } | { height: number, diameter: number } };

export type HeatPumpIndoorUnitFragment = { id: number, brand: string, model: string, enabled?: boolean | null, buffer: number, waterVolume: number, power?: string | null, noiseLevel: number, solutionType: IndoorUnitSolutionType, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, internet: HeatPumpInternet, app: HeatPumpApp, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } };

export type SolarPanelFragment = { id: number, brand: string, model: string, weight: number, annualProduction: number, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, type: PanelType, category: PanelCategory, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, compatibleInverters: Array<number>, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } };

export type InverterFragment = { id: number, brand: string, model: string, weight: number, capacity: number, efficiency: number, warrantyYears: number, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, compatibleBatteries?: Array<number> | null, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } };

export type BatteryFragment = { id: number, brand: string, model: string, weight: number, capacity: number, efficiency: number, warrantyYears?: number | null, warrantyCycles?: number | null, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } };

export type ImageFragment = { category?: string | null, url: string };

export type ResidenceHeatingFragment = { annualUsage: number, efficiency?: number | null, fuelSubtype?: string | null, fuelType: string, heatSource?: string | null, id: number, price?: number | null, priority: HeatingPriority, volumeUnit?: string | null };

export type RoofFragment = { height?: number | null, isGuessed?: boolean | null, maxPanelCoverage?: number | null, orientation: number, planeDepth: number, planeWidth: number, shadows?: RoofShadows | null };

export type OfferDispatchFragment = { id: number, type?: OfferPdfTypeEnum | null, sentAt?: number | null };

export type ProductUsageFragment = { produced: number, bought: number, sold: number, used: number, usedPercentage?: number | null, consumptionPerMonth?: Array<number> | null, productionPerMonth?: Array<number> | null, totalPrice: number, domesticPrice: number, fuelPrice?: number | null, boughtPrice?: number | null, netEarning?: number | null, soldPrice?: number | null, domesticDiscount: number, electricityDiscount?: number | null, totalEmission?: number | null, netSpentElectricity?: number | null };

export type AssortedProductFragment = { id: number, brand: string, model: string, descriptionId?: number | null, price: number, buyPrice?: number | null, datasheetUrl?: string | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } };

export type HeatPumpIndoorUnitsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type HeatPumpIndoorUnitsQuery = { heatPumpIndoorUnits: Array<{ id: number, brand: string, model: string, enabled?: boolean | null, buffer: number, waterVolume: number, power?: string | null, noiseLevel: number, solutionType: IndoorUnitSolutionType, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, internet: HeatPumpInternet, app: HeatPumpApp, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> };

export type HeatPumpOutdoorUnitsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type HeatPumpOutdoorUnitsQuery = { heatPumpOutdoorUnits: Array<{ id: number, datasheetUrl?: string | null, brand: string, model: string, compatibleIndoorUnits: Array<number>, noiseLevel: number, temperatureOut: number, waterLabel: string, copHotWater?: number | null, imageUrl?: string | null, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, notes?: string | null, scop: { floor: number, radiator: number }, energyLabel: { floor: string, radiator: string }, effect7: { floor: number, radiator: number }, effect12: { floor: number, radiator: number }, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> };

export type InvertersQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type InvertersQuery = { inverters: Array<{ id: number, brand: string, model: string, weight: number, capacity: number, efficiency: number, warrantyYears: number, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, compatibleBatteries?: Array<number> | null, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> };

export type OfferFragmentFragment = { createdAt?: number | null, id: number, notes?: string | null, preferred?: boolean | null, price?: number | null, tag: string, battery?: { id: number, brand: string, enabled?: boolean | null, capacity: number, efficiency: number, warrantyYears?: number | null, warrantyCycles?: number | null, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, customer?: { norlysPromotion?: boolean | null, email?: string | null, firstName?: string | null, lastName?: string | null, id: number, name: string, notes?: string | null, phoneNumber?: string | null, assignedAdvisor?: { firstName: string, lastName: string, email: string, phoneNumber?: string | null } | null } | null, expenses?: Array<{ description?: string | null, id: number, notes?: string | null, offerID: number, price: number, buyPrice: number, quantity: number, templateID?: number | null, title?: string | null, type?: OfferExpenseType | null, includedByDefault?: boolean | null }> | null, heatPumpIndoorUnit?: { id: number, brand: string, model: string, enabled?: boolean | null, buffer: number, waterVolume: number, power?: string | null, noiseLevel: number, solutionType: IndoorUnitSolutionType, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, internet: HeatPumpInternet, app: HeatPumpApp, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, heatPumpOutdoorUnit?: { id: number, brand: string, enabled?: boolean | null, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, compatibleIndoorUnits: Array<number>, noiseLevel: number, temperatureOut: number, copHotWater?: number | null, waterLabel: string, notes?: string | null, effect7: { floor: number, radiator: number }, effect12: { floor: number, radiator: number }, scop: { floor: number, radiator: number }, size: { height: number, width: number, depth: number } | { height: number, diameter: number }, energyLabel: { floor: string, radiator: string } } | null, inverter?: { id: number, brand: string, enabled?: boolean | null, capacity: number, efficiency: number, warrantyYears: number, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, residence?: { id: number, address?: { city: string, door?: string | null, floor?: string | null, houseNumber: string, postalCode: string, street: string } | null } | null, sentOffers?: Array<{ id: number, type?: OfferPdfTypeEnum | null, sentAt?: number | null }> | null, solarPanel?: { id: number, annualProduction: number, brand: string, enabled?: boolean | null, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, category: PanelCategory, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, type: PanelType, compatibleInverters: Array<number>, notes?: string | null, size: { height: number, width: number, depth: number } } | null, assortedProducts?: Array<{ id: number, brand: string, model: string, quantity?: number | null, price: number, buyPrice?: number | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> | null };

export type ArchiveOfferMutationVariables = Exact<{
  offerId: Scalars['Int']['input'];
}>;


export type ArchiveOfferMutation = { archiveOffer: boolean };

export type InsertOfferListMutationVariables = Exact<{
  heatPumpOfferList: Array<HeatPumpOfferInput>;
  solarOfferList: Array<SolarOfferInput>;
  assortedOfferList: Array<AssortedOfferInput>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  residenceId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InsertOfferListMutation = { insertOffers: Array<{ id: number }> };

export type CopyOfferMutationVariables = Exact<{
  offer: OfferInput;
  oldOfferId: Scalars['Int']['input'];
  archiveExisting?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CopyOfferMutation = { copyOffer: { id: number, tag: string } };

export type UpdateOfferNotesMutationVariables = Exact<{
  offerId: Scalars['Int']['input'];
  notes: Scalars['String']['input'];
}>;


export type UpdateOfferNotesMutation = { updateOfferNotes: { id: number } };

export type UpsertReservationMutationVariables = Exact<{
  offerId: Scalars['Int']['input'];
  reservation: Scalars['String']['input'];
}>;


export type UpsertReservationMutation = { upsertReservation: { id: number } };

export type FetchOfferQueryVariables = Exact<{
  offerId: Scalars['Int']['input'];
}>;


export type FetchOfferQuery = { offer?: { installationAccessCode: string, siteVisitAccessCode: string, finalPreview: string, preliminaryPreview: string, reservations?: string | null, residenceID: number, createdAt?: number | null, id: number, notes?: string | null, preferred?: boolean | null, price?: number | null, tag: string, expenses?: Array<{ description?: string | null, id: number, notes?: string | null, offerID: number, price: number, buyPrice: number, quantity: number, templateID?: number | null, title?: string | null, type?: OfferExpenseType | null, includedByDefault?: boolean | null }> | null, battery?: { id: number, brand: string, enabled?: boolean | null, capacity: number, efficiency: number, warrantyYears?: number | null, warrantyCycles?: number | null, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, customer?: { norlysPromotion?: boolean | null, email?: string | null, firstName?: string | null, lastName?: string | null, id: number, name: string, notes?: string | null, phoneNumber?: string | null, assignedAdvisor?: { firstName: string, lastName: string, email: string, phoneNumber?: string | null } | null } | null, heatPumpIndoorUnit?: { id: number, brand: string, model: string, enabled?: boolean | null, buffer: number, waterVolume: number, power?: string | null, noiseLevel: number, solutionType: IndoorUnitSolutionType, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, internet: HeatPumpInternet, app: HeatPumpApp, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, heatPumpOutdoorUnit?: { id: number, brand: string, enabled?: boolean | null, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, compatibleIndoorUnits: Array<number>, noiseLevel: number, temperatureOut: number, copHotWater?: number | null, waterLabel: string, notes?: string | null, effect7: { floor: number, radiator: number }, effect12: { floor: number, radiator: number }, scop: { floor: number, radiator: number }, size: { height: number, width: number, depth: number } | { height: number, diameter: number }, energyLabel: { floor: string, radiator: string } } | null, inverter?: { id: number, brand: string, enabled?: boolean | null, capacity: number, efficiency: number, warrantyYears: number, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, residence?: { id: number, address?: { city: string, door?: string | null, floor?: string | null, houseNumber: string, postalCode: string, street: string } | null } | null, sentOffers?: Array<{ id: number, type?: OfferPdfTypeEnum | null, sentAt?: number | null }> | null, solarPanel?: { id: number, annualProduction: number, brand: string, enabled?: boolean | null, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, category: PanelCategory, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, type: PanelType, compatibleInverters: Array<number>, notes?: string | null, size: { height: number, width: number, depth: number } } | null, assortedProducts?: Array<{ id: number, brand: string, model: string, quantity?: number | null, price: number, buyPrice?: number | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> | null } | null };

export type FetchOfferByTagQueryVariables = Exact<{
  offerTag: Scalars['String']['input'];
}>;


export type FetchOfferByTagQuery = { offerByTag?: { createdAt?: number | null, id: number, notes?: string | null, preferred?: boolean | null, price?: number | null, tag: string, battery?: { id: number, brand: string, enabled?: boolean | null, capacity: number, efficiency: number, warrantyYears?: number | null, warrantyCycles?: number | null, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, customer?: { norlysPromotion?: boolean | null, email?: string | null, firstName?: string | null, lastName?: string | null, id: number, name: string, notes?: string | null, phoneNumber?: string | null, assignedAdvisor?: { firstName: string, lastName: string, email: string, phoneNumber?: string | null } | null } | null, expenses?: Array<{ description?: string | null, id: number, notes?: string | null, offerID: number, price: number, buyPrice: number, quantity: number, templateID?: number | null, title?: string | null, type?: OfferExpenseType | null, includedByDefault?: boolean | null }> | null, heatPumpIndoorUnit?: { id: number, brand: string, model: string, enabled?: boolean | null, buffer: number, waterVolume: number, power?: string | null, noiseLevel: number, solutionType: IndoorUnitSolutionType, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, internet: HeatPumpInternet, app: HeatPumpApp, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, heatPumpOutdoorUnit?: { id: number, brand: string, enabled?: boolean | null, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, compatibleIndoorUnits: Array<number>, noiseLevel: number, temperatureOut: number, copHotWater?: number | null, waterLabel: string, notes?: string | null, effect7: { floor: number, radiator: number }, effect12: { floor: number, radiator: number }, scop: { floor: number, radiator: number }, size: { height: number, width: number, depth: number } | { height: number, diameter: number }, energyLabel: { floor: string, radiator: string } } | null, inverter?: { id: number, brand: string, enabled?: boolean | null, capacity: number, efficiency: number, warrantyYears: number, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, residence?: { id: number, address?: { city: string, door?: string | null, floor?: string | null, houseNumber: string, postalCode: string, street: string } | null } | null, sentOffers?: Array<{ id: number, type?: OfferPdfTypeEnum | null, sentAt?: number | null }> | null, solarPanel?: { id: number, annualProduction: number, brand: string, enabled?: boolean | null, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, category: PanelCategory, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, type: PanelType, compatibleInverters: Array<number>, notes?: string | null, size: { height: number, width: number, depth: number } } | null, assortedProducts?: Array<{ id: number, brand: string, model: string, quantity?: number | null, price: number, buyPrice?: number | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> | null } | null };

export type FetchOfferListQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['Int']['input']>;
  residenceId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FetchOfferListQuery = { offers?: Array<{ id: number, preliminaryPreview: string, price?: number | null, tag: string, assortedProducts?: Array<{ id: number, model: string }> | null, heatPumpOutdoorUnit?: { id: number, model: string } | null, heatPumpIndoorUnit?: { id: number, model: string } | null, residence?: { id: number, address?: { city: string, door?: string | null, floor?: string | null, houseNumber: string, postalCode: string, street: string } | null } | null, solarPanel?: { id: number, model: string } | null, inverter?: { id: number, model: string } | null, battery?: { id: number, model: string } | null, sentOffers?: Array<{ id: number, type?: OfferPdfTypeEnum | null, sentAt?: number | null }> | null }> | null };

export type FetchOverviewOfferListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<SortOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offerType?: InputMaybe<OfferType>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FetchOverviewOfferListQuery = { dashboardOffers: { count: number, offers: Array<{ id: number, customer?: { email?: string | null, firstName?: string | null, lastName?: string | null, id: number, name: string, notes?: string | null, phoneNumber?: string | null, assignedAdvisor?: { firstName: string, lastName: string, email: string, phoneNumber?: string | null } | null } | null, residence?: { id: number, address?: { city: string, door?: string | null, floor?: string | null, houseNumber: string, postalCode: string, street: string } | null } | null, solarPanel?: { id: number } | null, heatPumpOutdoorUnit?: { id: number } | null, assortedProducts?: Array<{ id: number }> | null }> } };

export type UpdateOfferProductPriceMutationVariables = Exact<{
  offerID: Scalars['Int']['input'];
  unitID: Scalars['Int']['input'];
  type: OfferProductType;
  price: Scalars['Float']['input'];
}>;


export type UpdateOfferProductPriceMutation = { updateOfferProductPrice: { id: number } };

export type OfferByCodeFragmentFragment = { createdAt?: number | null, id: number, notes?: string | null, preferred?: boolean | null, price?: number | null, tag: string, residence?: { id: number, addressID: number, area: number, areaHeated: number, areaNotHeated?: number | null, areaPartiallyHeated?: number | null, builtYear?: number | null, consumptionProfile?: ConsumptionProfile | null, createdAt: number, customerID: number, electricityPrice?: number | null, energyExpenditure: number, energyLabel?: EnergyLabelEnum | null, floors: number, heatDistribution: HeatDistributionTypeEnum, noiseWeight: WaterConsumptionDegreeEnum, radiatorFloorPercentage?: number | null, renovatedDegree?: RenovationDegreeEnum | null, renovatedYear?: number | null, residents?: number | null, roofType?: RoofType | null, type: ResidenceType, updatedAt?: number | null, waterConsumption: WaterConsumptionDegreeEnum, address?: { city: string, door?: string | null, floor?: string | null, houseNumber: string, postalCode: string, street: string } | null, consumption?: { profileKey: ConsumptionProfile, profileValue: Array<number> } | null, customer?: { email?: string | null, firstName?: string | null, lastName?: string | null, id: number, name: string, notes?: string | null, phoneNumber?: string | null, assignedAdvisor?: { firstName: string, lastName: string, email: string, phoneNumber?: string | null } | null } | null, electricCar?: { annualKilometersDriven: number, consumptionPerKilometer: number, id: number, percentageCharged: number } | null, images: Array<{ id?: number | null, residenceID?: number | null, category?: string | null, url: string }>, primaryHeating?: { annualUsage: number, efficiency?: number | null, fuelSubtype?: string | null, fuelType: string, heatSource?: string | null, id: number, price?: number | null, priority: HeatingPriority, volumeUnit?: string | null } | null, roofs?: Array<{ height?: number | null, isGuessed?: boolean | null, maxPanelCoverage?: number | null, orientation: number, planeDepth: number, planeWidth: number, shadows?: RoofShadows | null }> | null, secondaryHeating?: { annualUsage: number, efficiency?: number | null, fuelSubtype?: string | null, fuelType: string, heatSource?: string | null, id: number, price?: number | null, priority: HeatingPriority, volumeUnit?: string | null } | null } | null, battery?: { id: number, brand: string, enabled?: boolean | null, capacity: number, efficiency: number, warrantyYears?: number | null, warrantyCycles?: number | null, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, customer?: { norlysPromotion?: boolean | null, email?: string | null, firstName?: string | null, lastName?: string | null, id: number, name: string, notes?: string | null, phoneNumber?: string | null, assignedAdvisor?: { firstName: string, lastName: string, email: string, phoneNumber?: string | null } | null } | null, expenses?: Array<{ description?: string | null, id: number, notes?: string | null, offerID: number, price: number, buyPrice: number, quantity: number, templateID?: number | null, title?: string | null, type?: OfferExpenseType | null, includedByDefault?: boolean | null }> | null, heatPumpIndoorUnit?: { id: number, brand: string, model: string, enabled?: boolean | null, buffer: number, waterVolume: number, power?: string | null, noiseLevel: number, solutionType: IndoorUnitSolutionType, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, internet: HeatPumpInternet, app: HeatPumpApp, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, heatPumpOutdoorUnit?: { id: number, brand: string, enabled?: boolean | null, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, compatibleIndoorUnits: Array<number>, noiseLevel: number, temperatureOut: number, copHotWater?: number | null, waterLabel: string, notes?: string | null, effect7: { floor: number, radiator: number }, effect12: { floor: number, radiator: number }, scop: { floor: number, radiator: number }, size: { height: number, width: number, depth: number } | { height: number, diameter: number }, energyLabel: { floor: string, radiator: string } } | null, inverter?: { id: number, brand: string, enabled?: boolean | null, capacity: number, efficiency: number, warrantyYears: number, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, sentOffers?: Array<{ id: number, type?: OfferPdfTypeEnum | null, sentAt?: number | null }> | null, solarPanel?: { id: number, annualProduction: number, brand: string, enabled?: boolean | null, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, category: PanelCategory, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, type: PanelType, compatibleInverters: Array<number>, notes?: string | null, size: { height: number, width: number, depth: number } } | null, assortedProducts?: Array<{ id: number, brand: string, model: string, quantity?: number | null, price: number, buyPrice?: number | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> | null };

export type OfferByInstallationCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type OfferByInstallationCodeQuery = { offerByCode?: { createdAt?: number | null, id: number, notes?: string | null, preferred?: boolean | null, price?: number | null, tag: string, residence?: { id: number, addressID: number, area: number, areaHeated: number, areaNotHeated?: number | null, areaPartiallyHeated?: number | null, builtYear?: number | null, consumptionProfile?: ConsumptionProfile | null, createdAt: number, customerID: number, electricityPrice?: number | null, energyExpenditure: number, energyLabel?: EnergyLabelEnum | null, floors: number, heatDistribution: HeatDistributionTypeEnum, noiseWeight: WaterConsumptionDegreeEnum, radiatorFloorPercentage?: number | null, renovatedDegree?: RenovationDegreeEnum | null, renovatedYear?: number | null, residents?: number | null, roofType?: RoofType | null, type: ResidenceType, updatedAt?: number | null, waterConsumption: WaterConsumptionDegreeEnum, address?: { city: string, door?: string | null, floor?: string | null, houseNumber: string, postalCode: string, street: string } | null, consumption?: { profileKey: ConsumptionProfile, profileValue: Array<number> } | null, customer?: { email?: string | null, firstName?: string | null, lastName?: string | null, id: number, name: string, notes?: string | null, phoneNumber?: string | null, assignedAdvisor?: { firstName: string, lastName: string, email: string, phoneNumber?: string | null } | null } | null, electricCar?: { annualKilometersDriven: number, consumptionPerKilometer: number, id: number, percentageCharged: number } | null, images: Array<{ id?: number | null, residenceID?: number | null, category?: string | null, url: string }>, primaryHeating?: { annualUsage: number, efficiency?: number | null, fuelSubtype?: string | null, fuelType: string, heatSource?: string | null, id: number, price?: number | null, priority: HeatingPriority, volumeUnit?: string | null } | null, roofs?: Array<{ height?: number | null, isGuessed?: boolean | null, maxPanelCoverage?: number | null, orientation: number, planeDepth: number, planeWidth: number, shadows?: RoofShadows | null }> | null, secondaryHeating?: { annualUsage: number, efficiency?: number | null, fuelSubtype?: string | null, fuelType: string, heatSource?: string | null, id: number, price?: number | null, priority: HeatingPriority, volumeUnit?: string | null } | null } | null, battery?: { id: number, brand: string, enabled?: boolean | null, capacity: number, efficiency: number, warrantyYears?: number | null, warrantyCycles?: number | null, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, customer?: { norlysPromotion?: boolean | null, email?: string | null, firstName?: string | null, lastName?: string | null, id: number, name: string, notes?: string | null, phoneNumber?: string | null, assignedAdvisor?: { firstName: string, lastName: string, email: string, phoneNumber?: string | null } | null } | null, expenses?: Array<{ description?: string | null, id: number, notes?: string | null, offerID: number, price: number, buyPrice: number, quantity: number, templateID?: number | null, title?: string | null, type?: OfferExpenseType | null, includedByDefault?: boolean | null }> | null, heatPumpIndoorUnit?: { id: number, brand: string, model: string, enabled?: boolean | null, buffer: number, waterVolume: number, power?: string | null, noiseLevel: number, solutionType: IndoorUnitSolutionType, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, internet: HeatPumpInternet, app: HeatPumpApp, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, heatPumpOutdoorUnit?: { id: number, brand: string, enabled?: boolean | null, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, compatibleIndoorUnits: Array<number>, noiseLevel: number, temperatureOut: number, copHotWater?: number | null, waterLabel: string, notes?: string | null, effect7: { floor: number, radiator: number }, effect12: { floor: number, radiator: number }, scop: { floor: number, radiator: number }, size: { height: number, width: number, depth: number } | { height: number, diameter: number }, energyLabel: { floor: string, radiator: string } } | null, inverter?: { id: number, brand: string, enabled?: boolean | null, capacity: number, efficiency: number, warrantyYears: number, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, sentOffers?: Array<{ id: number, type?: OfferPdfTypeEnum | null, sentAt?: number | null }> | null, solarPanel?: { id: number, annualProduction: number, brand: string, enabled?: boolean | null, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, category: PanelCategory, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, type: PanelType, compatibleInverters: Array<number>, notes?: string | null, size: { height: number, width: number, depth: number } } | null, assortedProducts?: Array<{ id: number, brand: string, model: string, quantity?: number | null, price: number, buyPrice?: number | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> | null } | null };

export type OfferBySiteVisitCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type OfferBySiteVisitCodeQuery = { offerByCode?: { createdAt?: number | null, id: number, notes?: string | null, preferred?: boolean | null, price?: number | null, tag: string, residence?: { id: number, addressID: number, area: number, areaHeated: number, areaNotHeated?: number | null, areaPartiallyHeated?: number | null, builtYear?: number | null, consumptionProfile?: ConsumptionProfile | null, createdAt: number, customerID: number, electricityPrice?: number | null, energyExpenditure: number, energyLabel?: EnergyLabelEnum | null, floors: number, heatDistribution: HeatDistributionTypeEnum, noiseWeight: WaterConsumptionDegreeEnum, radiatorFloorPercentage?: number | null, renovatedDegree?: RenovationDegreeEnum | null, renovatedYear?: number | null, residents?: number | null, roofType?: RoofType | null, type: ResidenceType, updatedAt?: number | null, waterConsumption: WaterConsumptionDegreeEnum, address?: { city: string, door?: string | null, floor?: string | null, houseNumber: string, postalCode: string, street: string } | null, consumption?: { profileKey: ConsumptionProfile, profileValue: Array<number> } | null, customer?: { email?: string | null, firstName?: string | null, lastName?: string | null, id: number, name: string, notes?: string | null, phoneNumber?: string | null, assignedAdvisor?: { firstName: string, lastName: string, email: string, phoneNumber?: string | null } | null } | null, electricCar?: { annualKilometersDriven: number, consumptionPerKilometer: number, id: number, percentageCharged: number } | null, images: Array<{ id?: number | null, residenceID?: number | null, category?: string | null, url: string }>, primaryHeating?: { annualUsage: number, efficiency?: number | null, fuelSubtype?: string | null, fuelType: string, heatSource?: string | null, id: number, price?: number | null, priority: HeatingPriority, volumeUnit?: string | null } | null, roofs?: Array<{ height?: number | null, isGuessed?: boolean | null, maxPanelCoverage?: number | null, orientation: number, planeDepth: number, planeWidth: number, shadows?: RoofShadows | null }> | null, secondaryHeating?: { annualUsage: number, efficiency?: number | null, fuelSubtype?: string | null, fuelType: string, heatSource?: string | null, id: number, price?: number | null, priority: HeatingPriority, volumeUnit?: string | null } | null } | null, battery?: { id: number, brand: string, enabled?: boolean | null, capacity: number, efficiency: number, warrantyYears?: number | null, warrantyCycles?: number | null, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, customer?: { norlysPromotion?: boolean | null, email?: string | null, firstName?: string | null, lastName?: string | null, id: number, name: string, notes?: string | null, phoneNumber?: string | null, assignedAdvisor?: { firstName: string, lastName: string, email: string, phoneNumber?: string | null } | null } | null, expenses?: Array<{ description?: string | null, id: number, notes?: string | null, offerID: number, price: number, buyPrice: number, quantity: number, templateID?: number | null, title?: string | null, type?: OfferExpenseType | null, includedByDefault?: boolean | null }> | null, heatPumpIndoorUnit?: { id: number, brand: string, model: string, enabled?: boolean | null, buffer: number, waterVolume: number, power?: string | null, noiseLevel: number, solutionType: IndoorUnitSolutionType, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, internet: HeatPumpInternet, app: HeatPumpApp, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, heatPumpOutdoorUnit?: { id: number, brand: string, enabled?: boolean | null, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, compatibleIndoorUnits: Array<number>, noiseLevel: number, temperatureOut: number, copHotWater?: number | null, waterLabel: string, notes?: string | null, effect7: { floor: number, radiator: number }, effect12: { floor: number, radiator: number }, scop: { floor: number, radiator: number }, size: { height: number, width: number, depth: number } | { height: number, diameter: number }, energyLabel: { floor: string, radiator: string } } | null, inverter?: { id: number, brand: string, enabled?: boolean | null, capacity: number, efficiency: number, warrantyYears: number, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } } | null, sentOffers?: Array<{ id: number, type?: OfferPdfTypeEnum | null, sentAt?: number | null }> | null, solarPanel?: { id: number, annualProduction: number, brand: string, enabled?: boolean | null, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, category: PanelCategory, model: string, imageUrl?: string | null, price: number, buyPrice?: number | null, quantity?: number | null, weight: number, type: PanelType, compatibleInverters: Array<number>, notes?: string | null, size: { height: number, width: number, depth: number } } | null, assortedProducts?: Array<{ id: number, brand: string, model: string, quantity?: number | null, price: number, buyPrice?: number | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> | null } | null };

export type MarkOfferAsSentMutationVariables = Exact<{
  offerId: Scalars['Int']['input'];
  type: OfferPdfTypeEnum;
}>;


export type MarkOfferAsSentMutation = { markOfferAsSent: boolean };

export type SetOfferExpensesMutationVariables = Exact<{
  offerId: Scalars['Int']['input'];
  expenses: Array<OfferExpenseInput>;
}>;


export type SetOfferExpensesMutation = { setOfferExpenses: Array<{ id: number }> };

export type DeleteOfferExpensesMutationVariables = Exact<{
  offerId: Scalars['Int']['input'];
  expenseIds: Array<Scalars['Int']['input']>;
}>;


export type DeleteOfferExpensesMutation = { deleteOfferExpenses: boolean };

export type ExpenseTemplateListQueryVariables = Exact<{
  type: OfferType;
}>;


export type ExpenseTemplateListQuery = { expenseTemplates: Array<{ id: number, denominator?: string | null, buyPrice: number, price: number, title: string, type: OfferExpenseTemplateType }> };

export type RegeneratePreviewMutationVariables = Exact<{
  offerId: Scalars['Int']['input'];
  type: OfferPdfTypeEnum;
}>;


export type RegeneratePreviewMutation = { regeneratePreview: string };

export type UploadResidenceImagesMutationVariables = Exact<{
  residenceId: Scalars['Int']['input'];
  images: Array<Scalars['Upload']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type UploadResidenceImagesMutation = { uploadResidenceImages: Array<{ residenceID?: number | null, category?: string | null, url: string }> };

export type DeleteResidenceImageMutationVariables = Exact<{
  residenceId: Scalars['Int']['input'];
  imageUrl: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteResidenceImageMutation = { deleteResidenceImage: boolean };

export type UpsertResidenceMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
  residence: ResidenceInput;
  residenceId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpsertResidenceMutation = { upsertResidence: { id: number } };

export type ResidenceQueryVariables = Exact<{
  residenceId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ResidenceQuery = { residence?: { id: number, addressID: number, area: number, areaHeated: number, areaNotHeated?: number | null, areaPartiallyHeated?: number | null, builtYear?: number | null, consumptionProfile?: ConsumptionProfile | null, createdAt: number, customerID: number, electricityPrice?: number | null, energyExpenditure: number, energyLabel?: EnergyLabelEnum | null, floors: number, heatDistribution: HeatDistributionTypeEnum, heatingCircuits?: number | null, monthlyConsumptionProfile?: MonthlyConsumptionProfile | null, noiseWeight: WaterConsumptionDegreeEnum, radiatorFloorPercentage?: number | null, renovatedDegree?: RenovationDegreeEnum | null, renovatedYear?: number | null, residents?: number | null, roofType?: RoofType | null, type: ResidenceType, updatedAt?: number | null, waterConsumption: WaterConsumptionDegreeEnum, hasExistingSolarPanels?: boolean | null, address?: { city: string, door?: string | null, floor?: string | null, houseNumber: string, postalCode: string, street: string } | null, consumption?: { profileKey: ConsumptionProfile, profileValue: Array<number> } | null, customer?: { id: number, createdAt: number, eligibleForFinancing: boolean, name: string } | null, electricCar?: { annualKilometersDriven: number, consumptionPerKilometer: number, id: number, percentageCharged: number, monthlySubscriptionPrice?: number | null, isSubsidised?: boolean | null } | null, images: Array<{ id?: number | null, residenceID?: number | null, category?: string | null, url: string }>, monthlyConsumption?: { profileKey: MonthlyConsumptionProfile, profileValue: Array<number> } | null, primaryHeating?: { annualUsage: number, efficiency?: number | null, fuelSubtype?: string | null, fuelType: string, heatSource?: string | null, id: number, price?: number | null, priority: HeatingPriority, volumeUnit?: string | null } | null, roofs?: Array<{ height?: number | null, isGuessed?: boolean | null, maxPanelCoverage?: number | null, orientation: number, planeDepth: number, planeWidth: number, shadows?: RoofShadows | null }> | null, secondaryHeating?: { annualUsage: number, efficiency?: number | null, fuelSubtype?: string | null, fuelType: string, heatSource?: string | null, id: number, price?: number | null, priority: HeatingPriority, volumeUnit?: string | null } | null } | null };

export type ResidenceListQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ResidenceListQuery = { residences?: Array<{ id: number, address?: { city: string, door?: string | null, floor?: string | null, houseNumber: string, postalCode: string, street: string } | null }> | null };

export type SetResidenceRoofTypeMutationVariables = Exact<{
  residenceId: Scalars['Int']['input'];
  roofType: RoofType;
}>;


export type SetResidenceRoofTypeMutation = { setResidenceRoofType: boolean };

export type OfferSavingsQueryVariables = Exact<{
  residence: ResidenceInput;
  offer: OfferInput;
  address?: InputMaybe<AddressInput>;
  chosenHeating?: InputMaybe<Scalars['Float']['input']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']['input']>>;
  customerID?: InputMaybe<Scalars['Float']['input']>;
}>;


export type OfferSavingsQuery = { offerSavings: { before: { produced: number, bought: number, sold: number, used: number, usedPercentage?: number | null, consumptionPerMonth?: Array<number> | null, productionPerMonth?: Array<number> | null, totalPrice: number, domesticPrice: number, fuelPrice?: number | null, boughtPrice?: number | null, netEarning?: number | null, soldPrice?: number | null, domesticDiscount: number, electricityDiscount?: number | null, totalEmission?: number | null, netSpentElectricity?: number | null }, after: { produced: number, bought: number, sold: number, used: number, usedPercentage?: number | null, consumptionPerMonth?: Array<number> | null, productionPerMonth?: Array<number> | null, totalPrice: number, domesticPrice: number, fuelPrice?: number | null, boughtPrice?: number | null, netEarning?: number | null, soldPrice?: number | null, domesticDiscount: number, electricityDiscount?: number | null, totalEmission?: number | null, netSpentElectricity?: number | null }, saved: { price: number, emission: number, priceByYear: Array<number> } } };

export type SolarPackageSavingsQueryVariables = Exact<{
  residence: ResidenceInput;
}>;


export type SolarPackageSavingsQuery = { solarPackageSavings: Array<{ packageID: number, title?: string | null, savings: number, usedPercentage: number, quantity: number, totalPrice: number, totalSaved: number }> };

export type OfferSavingsWithAndWithoutBatteryQueryVariables = Exact<{
  residence: ResidenceInput;
  offerWithBattery: OfferInput;
  offerWithoutBattery: OfferInput;
  address?: InputMaybe<AddressInput>;
  chosenHeating?: InputMaybe<Scalars['Float']['input']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']['input']>>;
  customerID?: InputMaybe<Scalars['Float']['input']>;
}>;


export type OfferSavingsWithAndWithoutBatteryQuery = { withBattery: { before: { produced: number, bought: number, sold: number, used: number, usedPercentage?: number | null, consumptionPerMonth?: Array<number> | null, productionPerMonth?: Array<number> | null, totalPrice: number, domesticPrice: number, fuelPrice?: number | null, boughtPrice?: number | null, netEarning?: number | null, soldPrice?: number | null, domesticDiscount: number, electricityDiscount?: number | null, totalEmission?: number | null, netSpentElectricity?: number | null }, after: { produced: number, bought: number, sold: number, used: number, usedPercentage?: number | null, consumptionPerMonth?: Array<number> | null, productionPerMonth?: Array<number> | null, totalPrice: number, domesticPrice: number, fuelPrice?: number | null, boughtPrice?: number | null, netEarning?: number | null, soldPrice?: number | null, domesticDiscount: number, electricityDiscount?: number | null, totalEmission?: number | null, netSpentElectricity?: number | null }, saved: { price: number, emission: number } }, withoutBattery: { before: { produced: number, bought: number, sold: number, used: number, usedPercentage?: number | null, consumptionPerMonth?: Array<number> | null, productionPerMonth?: Array<number> | null, totalPrice: number, domesticPrice: number, fuelPrice?: number | null, boughtPrice?: number | null, netEarning?: number | null, soldPrice?: number | null, domesticDiscount: number, electricityDiscount?: number | null, totalEmission?: number | null, netSpentElectricity?: number | null }, after: { produced: number, bought: number, sold: number, used: number, usedPercentage?: number | null, consumptionPerMonth?: Array<number> | null, productionPerMonth?: Array<number> | null, totalPrice: number, domesticPrice: number, fuelPrice?: number | null, boughtPrice?: number | null, netEarning?: number | null, soldPrice?: number | null, domesticDiscount: number, electricityDiscount?: number | null, totalEmission?: number | null, netSpentElectricity?: number | null }, saved: { price: number, emission: number } } };

export type UpdateSiteVisitAnswerListMutationVariables = Exact<{
  answerList: Array<SiteVisitAnswerInput>;
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSiteVisitAnswerListMutation = { upsertSiteVisitAnswerList: boolean };

export type SiteVisitAnswerListQueryVariables = Exact<{
  residenceId: Scalars['Int']['input'];
}>;


export type SiteVisitAnswerListQuery = { siteVisitAnswerList: Array<{ answer?: string | null, id?: number | null, question?: SiteVisitQuestion | null, residenceId: number }> };

export type UploadSiteVisitFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  offerID: Scalars['Int']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type UploadSiteVisitFileMutation = { uploadSiteVisitFile: string };

export type DeleteSiteVisitFileMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteSiteVisitFileMutation = { deleteSiteVisitFile: boolean };

export type SiteVisitFilesQueryVariables = Exact<{
  offerID: Scalars['Int']['input'];
}>;


export type SiteVisitFilesQuery = { siteVisitFiles: Array<{ id: number, offerID: number, url: string, name: string }> };

export type SolarPanelsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type SolarPanelsQuery = { solarPanels: Array<{ id: number, brand: string, model: string, weight: number, annualProduction: number, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, type: PanelType, category: PanelCategory, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, compatibleInverters: Array<number>, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } }> };

export type SolarProductPackagesQueryVariables = Exact<{ [key: string]: never; }>;


export type SolarProductPackagesQuery = { solarProductPackages: Array<{ packageID: number, discount?: number | null, discountWithoutInstallation?: number | null, title?: string | null, defaultBatteryID?: number | null, solarPanel: { id: number, brand: string, model: string, weight: number, annualProduction: number, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, type: PanelType, category: PanelCategory, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, compatibleInverters: Array<number>, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } }, inverter: { id: number, brand: string, model: string, weight: number, capacity: number, efficiency: number, warrantyYears: number, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, compatibleBatteries?: Array<number> | null, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }, batteries?: Array<{ id: number, brand: string, model: string, weight: number, capacity: number, efficiency: number, warrantyYears?: number | null, warrantyCycles?: number | null, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> | null }> };

export type RecommendedSolarPackageQueryVariables = Exact<{
  residence: ResidenceInput;
}>;


export type RecommendedSolarPackageQuery = { recommendedSolarPackage: { discount?: number | null, discountWithoutInstallation?: number | null, solarPanel: { id: number, brand: string, model: string, weight: number, annualProduction: number, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, type: PanelType, category: PanelCategory, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, compatibleInverters: Array<number>, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } }, inverter: { id: number, brand: string, model: string, weight: number, capacity: number, efficiency: number, warrantyYears: number, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, compatibleBatteries?: Array<number> | null, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }, batteries?: Array<{ id: number, brand: string, model: string, weight: number, capacity: number, efficiency: number, warrantyYears?: number | null, warrantyCycles?: number | null, preferred?: boolean | null, quantity?: number | null, price: number, buyPrice?: number | null, datasheetUrl?: string | null, imageUrl?: string | null, notes?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> | null } };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { me: { id: number, name: string, isAdmin: boolean } };

export type BodilAdvisorListQueryVariables = Exact<{ [key: string]: never; }>;


export type BodilAdvisorListQuery = { bodilAdvisors: Array<{ firstName: string, lastName: string, id: number }> };

export const CompositeFigureFragmentDoc = `
    fragment CompositeFigure on CompositeFigure {
  floor
  radiator
}
    `;
export const BoxSizeFragmentDoc = `
    fragment BoxSize on BoxSize {
  height
  width
  depth
}
    `;
export const CylinderSizeFragmentDoc = `
    fragment CylinderSize on CylinderSize {
  height
  diameter
}
    `;
export const HeatPumpOutdoorUnitFragmentDoc = `
    fragment HeatPumpOutdoorUnit on HeatPumpOutdoorUnit {
  id
  datasheetUrl
  brand
  model
  compatibleIndoorUnits
  noiseLevel
  temperatureOut
  waterLabel
  copHotWater
  scop {
    ...CompositeFigure
  }
  energyLabel {
    floor
    radiator
  }
  effect7 {
    ...CompositeFigure
  }
  effect12 {
    ...CompositeFigure
  }
  imageUrl
  size {
    ... on BoxSize {
      ...BoxSize
    }
    ... on CylinderSize {
      ...CylinderSize
    }
  }
  preferred
  quantity
  price
  buyPrice
  notes
}
    `;
export const SolarPanelFragmentDoc = `
    fragment SolarPanel on SolarPanel {
  id
  brand
  model
  weight
  annualProduction
  capacity
  productWarrantyYears
  performanceWarrantyYears
  degradationPerYear
  type
  category
  preferred
  quantity
  price
  buyPrice
  compatibleInverters
  datasheetUrl
  imageUrl
  notes
  size {
    ...BoxSize
  }
}
    `;
export const InverterFragmentDoc = `
    fragment Inverter on Inverter {
  id
  brand
  model
  weight
  capacity
  efficiency
  warrantyYears
  preferred
  quantity
  price
  buyPrice
  compatibleBatteries
  datasheetUrl
  imageUrl
  notes
  size {
    ... on BoxSize {
      ...BoxSize
    }
    ... on CylinderSize {
      ...CylinderSize
    }
  }
}
    `;
export const BatteryFragmentDoc = `
    fragment Battery on Battery {
  id
  brand
  model
  weight
  capacity
  efficiency
  warrantyYears
  warrantyCycles
  preferred
  quantity
  price
  buyPrice
  datasheetUrl
  imageUrl
  notes
  size {
    ... on BoxSize {
      ...BoxSize
    }
    ... on CylinderSize {
      ...CylinderSize
    }
  }
}
    `;
export const ImageFragmentDoc = `
    fragment Image on Image {
  category
  url
}
    `;
export const ProductUsageFragmentDoc = `
    fragment ProductUsage on ProductUsage {
  produced
  bought
  sold
  used
  usedPercentage
  consumptionPerMonth
  productionPerMonth
  totalPrice
  domesticPrice
  fuelPrice
  boughtPrice
  netEarning
  soldPrice
  domesticDiscount
  electricityDiscount
  totalEmission
  netSpentElectricity
}
    `;
export const AssortedProductFragmentDoc = `
    fragment AssortedProduct on AssortedProduct {
  id
  brand
  model
  descriptionId
  price
  buyPrice
  size {
    ... on BoxSize {
      ...BoxSize
    }
    ... on CylinderSize {
      ...CylinderSize
    }
  }
  datasheetUrl
  imageUrl
}
    `;
export const CustomerFragmentDoc = `
    fragment Customer on Customer {
  email
  firstName
  lastName
  id
  name
  notes
  phoneNumber
  assignedAdvisor {
    firstName
    lastName
    email
    phoneNumber
  }
}
    `;
export const OfferExpenseFragmentDoc = `
    fragment OfferExpense on OfferExpense {
  description
  id
  notes
  offerID
  price
  buyPrice
  quantity
  templateID
  title
  type
  includedByDefault
}
    `;
export const HeatPumpIndoorUnitFragmentDoc = `
    fragment HeatPumpIndoorUnit on HeatPumpIndoorUnit {
  id
  brand
  model
  enabled
  buffer
  waterVolume
  power
  noiseLevel
  solutionType
  preferred
  quantity
  price
  buyPrice
  internet
  app
  size {
    ... on BoxSize {
      ...BoxSize
    }
    ... on CylinderSize {
      ...CylinderSize
    }
  }
  datasheetUrl
  imageUrl
  notes
}
    `;
export const AddressFragmentDoc = `
    fragment Address on Address {
  city
  door
  floor
  houseNumber
  postalCode
  street
}
    `;
export const OfferDispatchFragmentDoc = `
    fragment OfferDispatch on OfferDispatch {
  id
  type
  sentAt
}
    `;
export const OfferFragmentFragmentDoc = `
    fragment OfferFragment on Offer {
  createdAt
  id
  notes
  preferred
  price
  tag
  battery {
    id
    brand
    enabled
    capacity
    efficiency
    warrantyYears
    warrantyCycles
    model
    imageUrl
    price
    buyPrice
    quantity
    size {
      ... on BoxSize {
        ...BoxSize
      }
      ... on CylinderSize {
        ...CylinderSize
      }
    }
    weight
    notes
  }
  customer {
    ...Customer
    norlysPromotion
  }
  expenses {
    ...OfferExpense
  }
  heatPumpIndoorUnit {
    ...HeatPumpIndoorUnit
  }
  heatPumpOutdoorUnit {
    id
    brand
    enabled
    effect7 {
      ...CompositeFigure
    }
    effect12 {
      ...CompositeFigure
    }
    model
    imageUrl
    price
    buyPrice
    scop {
      ...CompositeFigure
    }
    quantity
    size {
      ... on BoxSize {
        ...BoxSize
      }
      ... on CylinderSize {
        ...CylinderSize
      }
    }
    compatibleIndoorUnits
    energyLabel {
      floor
      radiator
    }
    noiseLevel
    temperatureOut
    copHotWater
    waterLabel
    notes
  }
  inverter {
    id
    brand
    enabled
    capacity
    efficiency
    warrantyYears
    model
    imageUrl
    price
    buyPrice
    quantity
    size {
      ... on BoxSize {
        ...BoxSize
      }
      ... on CylinderSize {
        ...CylinderSize
      }
    }
    weight
    notes
  }
  residence {
    id
    address {
      ...Address
    }
  }
  sentOffers {
    ...OfferDispatch
  }
  solarPanel {
    id
    annualProduction
    brand
    enabled
    capacity
    productWarrantyYears
    performanceWarrantyYears
    degradationPerYear
    category
    model
    imageUrl
    price
    buyPrice
    quantity
    size {
      ...BoxSize
    }
    weight
    type
    compatibleInverters
    notes
  }
  assortedProducts {
    id
    brand
    model
    quantity
    price
    buyPrice
    imageUrl
    size {
      ... on BoxSize {
        ...BoxSize
      }
      ... on CylinderSize {
        ...CylinderSize
      }
    }
  }
}
    `;
export const ResidenceHeatingFragmentDoc = `
    fragment ResidenceHeating on ResidenceHeating {
  annualUsage
  efficiency
  fuelSubtype
  fuelType
  heatSource
  id
  price
  priority
  volumeUnit
}
    `;
export const RoofFragmentDoc = `
    fragment Roof on Roof {
  height
  isGuessed
  maxPanelCoverage
  orientation
  planeDepth
  planeWidth
  shadows
}
    `;
export const OfferByCodeFragmentFragmentDoc = `
    fragment OfferByCodeFragment on Offer {
  ...OfferFragment
  residence {
    id
    address {
      ...Address
    }
    addressID
    area
    areaHeated
    areaNotHeated
    areaPartiallyHeated
    builtYear
    consumption {
      profileKey
      profileValue
    }
    consumptionProfile
    createdAt
    customerID
    customer {
      ...Customer
    }
    electricCar {
      annualKilometersDriven
      consumptionPerKilometer
      id
      percentageCharged
    }
    electricityPrice
    energyExpenditure
    energyLabel
    floors
    heatDistribution
    id
    images {
      id
      residenceID
      category
      url
    }
    noiseWeight
    primaryHeating {
      ...ResidenceHeating
    }
    radiatorFloorPercentage
    renovatedDegree
    renovatedYear
    residents
    roofs {
      ...Roof
    }
    roofType
    secondaryHeating {
      ...ResidenceHeating
    }
    type
    updatedAt
    waterConsumption
  }
}
    `;
export const AssortedProductsDocument = `
    query assortedProducts($ids: [Int!]) {
  assortedProducts(ids: $ids) {
    ...AssortedProduct
  }
}
    ${AssortedProductFragmentDoc}
${BoxSizeFragmentDoc}
${CylinderSizeFragmentDoc}`;
export const useAssortedProductsQuery = <
      TData = AssortedProductsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AssortedProductsQueryVariables,
      options?: UseQueryOptions<AssortedProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AssortedProductsQuery, TError, TData>(
      variables === undefined ? ['assortedProducts'] : ['assortedProducts', variables],
      fetcher<AssortedProductsQuery, AssortedProductsQueryVariables>(client, AssortedProductsDocument, variables, headers),
      options
    );

useAssortedProductsQuery.getKey = (variables?: AssortedProductsQueryVariables) => variables === undefined ? ['assortedProducts'] : ['assortedProducts', variables];
;

export const RefreshLoginDocument = `
    mutation refreshLogin($refreshToken: String!) {
  refreshLogin(refreshToken: $refreshToken) {
    accessToken
    refreshToken
  }
}
    `;
export const useRefreshLoginMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RefreshLoginMutation, TError, RefreshLoginMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RefreshLoginMutation, TError, RefreshLoginMutationVariables, TContext>(
      ['refreshLogin'],
      (variables?: RefreshLoginMutationVariables) => fetcher<RefreshLoginMutation, RefreshLoginMutationVariables>(client, RefreshLoginDocument, variables, headers)(),
      options
    );
export const LogoutDocument = `
    mutation logout($refreshToken: String!) {
  logout(refreshToken: $refreshToken)
}
    `;
export const useLogoutMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<LogoutMutation, TError, LogoutMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<LogoutMutation, TError, LogoutMutationVariables, TContext>(
      ['logout'],
      (variables?: LogoutMutationVariables) => fetcher<LogoutMutation, LogoutMutationVariables>(client, LogoutDocument, variables, headers)(),
      options
    );
export const BatteriesDocument = `
    query batteries($ids: [Int!]) {
  batteries(ids: $ids) {
    ...Battery
  }
}
    ${BatteryFragmentDoc}
${BoxSizeFragmentDoc}
${CylinderSizeFragmentDoc}`;
export const useBatteriesQuery = <
      TData = BatteriesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: BatteriesQueryVariables,
      options?: UseQueryOptions<BatteriesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<BatteriesQuery, TError, TData>(
      variables === undefined ? ['batteries'] : ['batteries', variables],
      fetcher<BatteriesQuery, BatteriesQueryVariables>(client, BatteriesDocument, variables, headers),
      options
    );

useBatteriesQuery.getKey = (variables?: BatteriesQueryVariables) => variables === undefined ? ['batteries'] : ['batteries', variables];
;

export const BbrLookupByAddressDocument = `
    query bbrLookupByAddress($address: AddressInput!) {
  bbrLookupByAddress(address: $address) {
    type
    floors
    residents
    builtYear
    renovatedYear
    renovatedDegree
    area
    areaHeated
    areaNotHeated
    energyExpenditure
    energyLabel
    primaryHeating {
      heatSource
      annualUsage
      price
      efficiency
      fuelType
      fuelSubtype
      volumeUnit
    }
    secondaryHeating {
      heatSource
    }
    roofs {
      orientation
      planeWidth
      planeDepth
      height
      maxPanelCoverage
      shadows
      isGuessed
    }
  }
}
    `;
export const useBbrLookupByAddressQuery = <
      TData = BbrLookupByAddressQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: BbrLookupByAddressQueryVariables,
      options?: UseQueryOptions<BbrLookupByAddressQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<BbrLookupByAddressQuery, TError, TData>(
      ['bbrLookupByAddress', variables],
      fetcher<BbrLookupByAddressQuery, BbrLookupByAddressQueryVariables>(client, BbrLookupByAddressDocument, variables, headers),
      options
    );

useBbrLookupByAddressQuery.getKey = (variables: BbrLookupByAddressQueryVariables) => ['bbrLookupByAddress', variables];
;

export const BbrLookupByDawaIdDocument = `
    query bbrLookupByDawaId($dawaId: String!) {
  bbrLookupByDawaId(dawaId: $dawaId) {
    type
    floors
    residents
    builtYear
    renovatedYear
    renovatedDegree
    area
    areaHeated
    areaNotHeated
    energyExpenditure
    energyLabel
    primaryHeating {
      heatSource
      annualUsage
      price
      efficiency
      fuelType
      fuelSubtype
      volumeUnit
    }
    secondaryHeating {
      heatSource
    }
    roofs {
      orientation
      planeWidth
      planeDepth
      height
      maxPanelCoverage
      shadows
      isGuessed
    }
  }
}
    `;
export const useBbrLookupByDawaIdQuery = <
      TData = BbrLookupByDawaIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: BbrLookupByDawaIdQueryVariables,
      options?: UseQueryOptions<BbrLookupByDawaIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<BbrLookupByDawaIdQuery, TError, TData>(
      ['bbrLookupByDawaId', variables],
      fetcher<BbrLookupByDawaIdQuery, BbrLookupByDawaIdQueryVariables>(client, BbrLookupByDawaIdDocument, variables, headers),
      options
    );

useBbrLookupByDawaIdQuery.getKey = (variables: BbrLookupByDawaIdQueryVariables) => ['bbrLookupByDawaId', variables];
;

export const SyncContactInformationWithCrmDocument = `
    mutation syncContactInformationWithCRM($residenceId: Int!) {
  syncContactInformationWithCRM(residenceId: $residenceId)
}
    `;
export const useSyncContactInformationWithCrmMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SyncContactInformationWithCrmMutation, TError, SyncContactInformationWithCrmMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SyncContactInformationWithCrmMutation, TError, SyncContactInformationWithCrmMutationVariables, TContext>(
      ['syncContactInformationWithCRM'],
      (variables?: SyncContactInformationWithCrmMutationVariables) => fetcher<SyncContactInformationWithCrmMutation, SyncContactInformationWithCrmMutationVariables>(client, SyncContactInformationWithCrmDocument, variables, headers)(),
      options
    );
export const SearchCrmCustomersDocument = `
    query searchCRMCustomers($email: String!) {
  searchCRMCustomers(email: $email) {
    email
    firstName
    id
    lastName
    phoneNumber
  }
}
    `;
export const useSearchCrmCustomersQuery = <
      TData = SearchCrmCustomersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SearchCrmCustomersQueryVariables,
      options?: UseQueryOptions<SearchCrmCustomersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SearchCrmCustomersQuery, TError, TData>(
      ['searchCRMCustomers', variables],
      fetcher<SearchCrmCustomersQuery, SearchCrmCustomersQueryVariables>(client, SearchCrmCustomersDocument, variables, headers),
      options
    );

useSearchCrmCustomersQuery.getKey = (variables: SearchCrmCustomersQueryVariables) => ['searchCRMCustomers', variables];
;

export const CrmCustomerFieldValuesDocument = `
    query crmCustomerFieldValues($id: String!) {
  crmCustomerFieldValues(id: $id) {
    address
    assignedAdvisor
    financialAdvisor
    leadOrigin
    notes
  }
}
    `;
export const useCrmCustomerFieldValuesQuery = <
      TData = CrmCustomerFieldValuesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CrmCustomerFieldValuesQueryVariables,
      options?: UseQueryOptions<CrmCustomerFieldValuesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CrmCustomerFieldValuesQuery, TError, TData>(
      ['crmCustomerFieldValues', variables],
      fetcher<CrmCustomerFieldValuesQuery, CrmCustomerFieldValuesQueryVariables>(client, CrmCustomerFieldValuesDocument, variables, headers),
      options
    );

useCrmCustomerFieldValuesQuery.getKey = (variables: CrmCustomerFieldValuesQueryVariables) => ['crmCustomerFieldValues', variables];
;

export const SyncOfferInformationWithCrmDocument = `
    mutation syncOfferInformationWithCRM($offerId: Int!) {
  syncOfferInformationWithCRM(offerId: $offerId)
}
    `;
export const useSyncOfferInformationWithCrmMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SyncOfferInformationWithCrmMutation, TError, SyncOfferInformationWithCrmMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SyncOfferInformationWithCrmMutation, TError, SyncOfferInformationWithCrmMutationVariables, TContext>(
      ['syncOfferInformationWithCRM'],
      (variables?: SyncOfferInformationWithCrmMutationVariables) => fetcher<SyncOfferInformationWithCrmMutation, SyncOfferInformationWithCrmMutationVariables>(client, SyncOfferInformationWithCrmDocument, variables, headers)(),
      options
    );
export const CustomerDocument = `
    query customer($email: String, $id: Int) {
  customer(email: $email, id: $id) {
    ...Customer
    assignedAdvisorId
    includeHeatPumpSubsidy
    usePriceInflation
    createdAt
    eligibleForFinancing
    financialAdvisor
    financingProvider
    leadOrigin
    norlysPromotion
  }
}
    ${CustomerFragmentDoc}`;
export const useCustomerQuery = <
      TData = CustomerQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CustomerQueryVariables,
      options?: UseQueryOptions<CustomerQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerQuery, TError, TData>(
      variables === undefined ? ['customer'] : ['customer', variables],
      fetcher<CustomerQuery, CustomerQueryVariables>(client, CustomerDocument, variables, headers),
      options
    );

useCustomerQuery.getKey = (variables?: CustomerQueryVariables) => variables === undefined ? ['customer'] : ['customer', variables];
;

export const SearchCustomersDocument = `
    query searchCustomers($search: String!) {
  searchCustomers(search: $search) {
    ...Customer
    assignedAdvisorId
    financialAdvisor
    financingProvider
    leadOrigin
    norlysPromotion
    includeHeatPumpSubsidy
    usePriceInflation
  }
}
    ${CustomerFragmentDoc}`;
export const useSearchCustomersQuery = <
      TData = SearchCustomersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SearchCustomersQueryVariables,
      options?: UseQueryOptions<SearchCustomersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SearchCustomersQuery, TError, TData>(
      ['searchCustomers', variables],
      fetcher<SearchCustomersQuery, SearchCustomersQueryVariables>(client, SearchCustomersDocument, variables, headers),
      options
    );

useSearchCustomersQuery.getKey = (variables: SearchCustomersQueryVariables) => ['searchCustomers', variables];
;

export const SearchCustomersByEmailDocument = `
    query searchCustomersByEmail($email: String!) {
  searchCustomersByEmail(email: $email) {
    id
  }
}
    `;
export const useSearchCustomersByEmailQuery = <
      TData = SearchCustomersByEmailQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SearchCustomersByEmailQueryVariables,
      options?: UseQueryOptions<SearchCustomersByEmailQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SearchCustomersByEmailQuery, TError, TData>(
      ['searchCustomersByEmail', variables],
      fetcher<SearchCustomersByEmailQuery, SearchCustomersByEmailQueryVariables>(client, SearchCustomersByEmailDocument, variables, headers),
      options
    );

useSearchCustomersByEmailQuery.getKey = (variables: SearchCustomersByEmailQueryVariables) => ['searchCustomersByEmail', variables];
;

export const UpsertCustomerDocument = `
    mutation upsertCustomer($customer: CustomerInput!, $id: Int) {
  upsertCustomer(customer: $customer, id: $id) {
    id
  }
}
    `;
export const useUpsertCustomerMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpsertCustomerMutation, TError, UpsertCustomerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpsertCustomerMutation, TError, UpsertCustomerMutationVariables, TContext>(
      ['upsertCustomer'],
      (variables?: UpsertCustomerMutationVariables) => fetcher<UpsertCustomerMutation, UpsertCustomerMutationVariables>(client, UpsertCustomerDocument, variables, headers)(),
      options
    );
export const EnergyOptionsDocument = `
    query energyOptions($residenceId: Int) {
  energyOptions(residenceId: $residenceId) {
    code
    denominator
    numerator
    valueNumber
  }
}
    `;
export const useEnergyOptionsQuery = <
      TData = EnergyOptionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: EnergyOptionsQueryVariables,
      options?: UseQueryOptions<EnergyOptionsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<EnergyOptionsQuery, TError, TData>(
      variables === undefined ? ['energyOptions'] : ['energyOptions', variables],
      fetcher<EnergyOptionsQuery, EnergyOptionsQueryVariables>(client, EnergyOptionsDocument, variables, headers),
      options
    );

useEnergyOptionsQuery.getKey = (variables?: EnergyOptionsQueryVariables) => variables === undefined ? ['energyOptions'] : ['energyOptions', variables];
;

export const NewOfferExpensesDocument = `
    query newOfferExpenses {
  newOfferExpenses {
    heatPump {
      title
      description
      price
      buyPrice
      type
      minimumProducts
      includedByDefault
    }
    solar {
      title
      description
      price
      buyPrice
      type
      minimumProducts
      includedByDefault
    }
  }
}
    `;
export const useNewOfferExpensesQuery = <
      TData = NewOfferExpensesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: NewOfferExpensesQueryVariables,
      options?: UseQueryOptions<NewOfferExpensesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<NewOfferExpensesQuery, TError, TData>(
      variables === undefined ? ['newOfferExpenses'] : ['newOfferExpenses', variables],
      fetcher<NewOfferExpensesQuery, NewOfferExpensesQueryVariables>(client, NewOfferExpensesDocument, variables, headers),
      options
    );

useNewOfferExpensesQuery.getKey = (variables?: NewOfferExpensesQueryVariables) => variables === undefined ? ['newOfferExpenses'] : ['newOfferExpenses', variables];
;

export const HeatPumpIndoorUnitsDocument = `
    query heatPumpIndoorUnits($ids: [Int!]) {
  heatPumpIndoorUnits(ids: $ids) {
    ...HeatPumpIndoorUnit
  }
}
    ${HeatPumpIndoorUnitFragmentDoc}
${BoxSizeFragmentDoc}
${CylinderSizeFragmentDoc}`;
export const useHeatPumpIndoorUnitsQuery = <
      TData = HeatPumpIndoorUnitsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: HeatPumpIndoorUnitsQueryVariables,
      options?: UseQueryOptions<HeatPumpIndoorUnitsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<HeatPumpIndoorUnitsQuery, TError, TData>(
      variables === undefined ? ['heatPumpIndoorUnits'] : ['heatPumpIndoorUnits', variables],
      fetcher<HeatPumpIndoorUnitsQuery, HeatPumpIndoorUnitsQueryVariables>(client, HeatPumpIndoorUnitsDocument, variables, headers),
      options
    );

useHeatPumpIndoorUnitsQuery.getKey = (variables?: HeatPumpIndoorUnitsQueryVariables) => variables === undefined ? ['heatPumpIndoorUnits'] : ['heatPumpIndoorUnits', variables];
;

export const HeatPumpOutdoorUnitsDocument = `
    query heatPumpOutdoorUnits($ids: [Int!]) {
  heatPumpOutdoorUnits(ids: $ids) {
    ...HeatPumpOutdoorUnit
  }
}
    ${HeatPumpOutdoorUnitFragmentDoc}
${CompositeFigureFragmentDoc}
${BoxSizeFragmentDoc}
${CylinderSizeFragmentDoc}`;
export const useHeatPumpOutdoorUnitsQuery = <
      TData = HeatPumpOutdoorUnitsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: HeatPumpOutdoorUnitsQueryVariables,
      options?: UseQueryOptions<HeatPumpOutdoorUnitsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<HeatPumpOutdoorUnitsQuery, TError, TData>(
      variables === undefined ? ['heatPumpOutdoorUnits'] : ['heatPumpOutdoorUnits', variables],
      fetcher<HeatPumpOutdoorUnitsQuery, HeatPumpOutdoorUnitsQueryVariables>(client, HeatPumpOutdoorUnitsDocument, variables, headers),
      options
    );

useHeatPumpOutdoorUnitsQuery.getKey = (variables?: HeatPumpOutdoorUnitsQueryVariables) => variables === undefined ? ['heatPumpOutdoorUnits'] : ['heatPumpOutdoorUnits', variables];
;

export const InvertersDocument = `
    query inverters($ids: [Int!]) {
  inverters(ids: $ids) {
    ...Inverter
  }
}
    ${InverterFragmentDoc}
${BoxSizeFragmentDoc}
${CylinderSizeFragmentDoc}`;
export const useInvertersQuery = <
      TData = InvertersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: InvertersQueryVariables,
      options?: UseQueryOptions<InvertersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<InvertersQuery, TError, TData>(
      variables === undefined ? ['inverters'] : ['inverters', variables],
      fetcher<InvertersQuery, InvertersQueryVariables>(client, InvertersDocument, variables, headers),
      options
    );

useInvertersQuery.getKey = (variables?: InvertersQueryVariables) => variables === undefined ? ['inverters'] : ['inverters', variables];
;

export const ArchiveOfferDocument = `
    mutation archiveOffer($offerId: Int!) {
  archiveOffer(id: $offerId)
}
    `;
export const useArchiveOfferMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ArchiveOfferMutation, TError, ArchiveOfferMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ArchiveOfferMutation, TError, ArchiveOfferMutationVariables, TContext>(
      ['archiveOffer'],
      (variables?: ArchiveOfferMutationVariables) => fetcher<ArchiveOfferMutation, ArchiveOfferMutationVariables>(client, ArchiveOfferDocument, variables, headers)(),
      options
    );
export const InsertOfferListDocument = `
    mutation insertOfferList($heatPumpOfferList: [HeatPumpOfferInput!]!, $solarOfferList: [SolarOfferInput!]!, $assortedOfferList: [AssortedOfferInput!]!, $customerId: Int, $residenceId: Int) {
  insertOffers(
    heatPumpOffers: $heatPumpOfferList
    solarOffers: $solarOfferList
    assortedOffers: $assortedOfferList
    customerID: $customerId
    residenceID: $residenceId
  ) {
    id
  }
}
    `;
export const useInsertOfferListMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertOfferListMutation, TError, InsertOfferListMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<InsertOfferListMutation, TError, InsertOfferListMutationVariables, TContext>(
      ['insertOfferList'],
      (variables?: InsertOfferListMutationVariables) => fetcher<InsertOfferListMutation, InsertOfferListMutationVariables>(client, InsertOfferListDocument, variables, headers)(),
      options
    );
export const CopyOfferDocument = `
    mutation copyOffer($offer: OfferInput!, $oldOfferId: Int!, $archiveExisting: Boolean) {
  copyOffer(
    offer: $offer
    existingOfferID: $oldOfferId
    archiveExisting: $archiveExisting
  ) {
    id
    tag
  }
}
    `;
export const useCopyOfferMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CopyOfferMutation, TError, CopyOfferMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CopyOfferMutation, TError, CopyOfferMutationVariables, TContext>(
      ['copyOffer'],
      (variables?: CopyOfferMutationVariables) => fetcher<CopyOfferMutation, CopyOfferMutationVariables>(client, CopyOfferDocument, variables, headers)(),
      options
    );
export const UpdateOfferNotesDocument = `
    mutation updateOfferNotes($offerId: Int!, $notes: String!) {
  updateOfferNotes(offerID: $offerId, notes: $notes) {
    id
  }
}
    `;
export const useUpdateOfferNotesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateOfferNotesMutation, TError, UpdateOfferNotesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateOfferNotesMutation, TError, UpdateOfferNotesMutationVariables, TContext>(
      ['updateOfferNotes'],
      (variables?: UpdateOfferNotesMutationVariables) => fetcher<UpdateOfferNotesMutation, UpdateOfferNotesMutationVariables>(client, UpdateOfferNotesDocument, variables, headers)(),
      options
    );
export const UpsertReservationDocument = `
    mutation upsertReservation($offerId: Int!, $reservation: String!) {
  upsertReservation(offerID: $offerId, reservation: $reservation) {
    id
  }
}
    `;
export const useUpsertReservationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpsertReservationMutation, TError, UpsertReservationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpsertReservationMutation, TError, UpsertReservationMutationVariables, TContext>(
      ['upsertReservation'],
      (variables?: UpsertReservationMutationVariables) => fetcher<UpsertReservationMutation, UpsertReservationMutationVariables>(client, UpsertReservationDocument, variables, headers)(),
      options
    );
export const FetchOfferDocument = `
    query fetchOffer($offerId: Int!) {
  offer(id: $offerId) {
    ...OfferFragment
    installationAccessCode
    siteVisitAccessCode
    finalPreview
    preliminaryPreview
    reservations
    residenceID
    expenses {
      ...OfferExpense
    }
  }
}
    ${OfferFragmentFragmentDoc}
${BoxSizeFragmentDoc}
${CylinderSizeFragmentDoc}
${CustomerFragmentDoc}
${OfferExpenseFragmentDoc}
${HeatPumpIndoorUnitFragmentDoc}
${CompositeFigureFragmentDoc}
${AddressFragmentDoc}
${OfferDispatchFragmentDoc}`;
export const useFetchOfferQuery = <
      TData = FetchOfferQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FetchOfferQueryVariables,
      options?: UseQueryOptions<FetchOfferQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FetchOfferQuery, TError, TData>(
      ['fetchOffer', variables],
      fetcher<FetchOfferQuery, FetchOfferQueryVariables>(client, FetchOfferDocument, variables, headers),
      options
    );

useFetchOfferQuery.getKey = (variables: FetchOfferQueryVariables) => ['fetchOffer', variables];
;

export const FetchOfferByTagDocument = `
    query fetchOfferByTag($offerTag: String!) {
  offerByTag(offerTag: $offerTag) {
    ...OfferFragment
  }
}
    ${OfferFragmentFragmentDoc}
${BoxSizeFragmentDoc}
${CylinderSizeFragmentDoc}
${CustomerFragmentDoc}
${OfferExpenseFragmentDoc}
${HeatPumpIndoorUnitFragmentDoc}
${CompositeFigureFragmentDoc}
${AddressFragmentDoc}
${OfferDispatchFragmentDoc}`;
export const useFetchOfferByTagQuery = <
      TData = FetchOfferByTagQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FetchOfferByTagQueryVariables,
      options?: UseQueryOptions<FetchOfferByTagQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FetchOfferByTagQuery, TError, TData>(
      ['fetchOfferByTag', variables],
      fetcher<FetchOfferByTagQuery, FetchOfferByTagQueryVariables>(client, FetchOfferByTagDocument, variables, headers),
      options
    );

useFetchOfferByTagQuery.getKey = (variables: FetchOfferByTagQueryVariables) => ['fetchOfferByTag', variables];
;

export const FetchOfferListDocument = `
    query fetchOfferList($customerId: Int, $residenceId: Int, $archived: Boolean) {
  offers(customerID: $customerId, residenceID: $residenceId, archived: $archived) {
    id
    preliminaryPreview
    price
    tag
    assortedProducts {
      id
      model
    }
    heatPumpOutdoorUnit {
      id
      model
    }
    heatPumpIndoorUnit {
      id
      model
    }
    residence {
      id
      address {
        ...Address
      }
    }
    solarPanel {
      id
      model
    }
    inverter {
      id
      model
    }
    battery {
      id
      model
    }
    sentOffers {
      ...OfferDispatch
    }
  }
}
    ${AddressFragmentDoc}
${OfferDispatchFragmentDoc}`;
export const useFetchOfferListQuery = <
      TData = FetchOfferListQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: FetchOfferListQueryVariables,
      options?: UseQueryOptions<FetchOfferListQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FetchOfferListQuery, TError, TData>(
      variables === undefined ? ['fetchOfferList'] : ['fetchOfferList', variables],
      fetcher<FetchOfferListQuery, FetchOfferListQueryVariables>(client, FetchOfferListDocument, variables, headers),
      options
    );

useFetchOfferListQuery.getKey = (variables?: FetchOfferListQueryVariables) => variables === undefined ? ['fetchOfferList'] : ['fetchOfferList', variables];
;

export const FetchOverviewOfferListDocument = `
    query fetchOverviewOfferList($search: String, $orderBy: String, $orderDirection: SortOrder, $offset: Int, $limit: Int, $offerType: OfferType, $archived: Boolean) {
  dashboardOffers(
    search: $search
    orderBy: $orderBy
    orderDirection: $orderDirection
    offset: $offset
    limit: $limit
    offerType: $offerType
    archived: $archived
  ) {
    offers {
      id
      customer {
        ...Customer
      }
      residence {
        id
        address {
          ...Address
        }
      }
      solarPanel {
        id
      }
      heatPumpOutdoorUnit {
        id
      }
      assortedProducts {
        id
      }
    }
    count
  }
}
    ${CustomerFragmentDoc}
${AddressFragmentDoc}`;
export const useFetchOverviewOfferListQuery = <
      TData = FetchOverviewOfferListQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: FetchOverviewOfferListQueryVariables,
      options?: UseQueryOptions<FetchOverviewOfferListQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FetchOverviewOfferListQuery, TError, TData>(
      variables === undefined ? ['fetchOverviewOfferList'] : ['fetchOverviewOfferList', variables],
      fetcher<FetchOverviewOfferListQuery, FetchOverviewOfferListQueryVariables>(client, FetchOverviewOfferListDocument, variables, headers),
      options
    );

useFetchOverviewOfferListQuery.getKey = (variables?: FetchOverviewOfferListQueryVariables) => variables === undefined ? ['fetchOverviewOfferList'] : ['fetchOverviewOfferList', variables];
;

export const UpdateOfferProductPriceDocument = `
    mutation updateOfferProductPrice($offerID: Int!, $unitID: Int!, $type: OfferProductType!, $price: Float!) {
  updateOfferProductPrice(
    offerID: $offerID
    unitID: $unitID
    type: $type
    price: $price
  ) {
    id
  }
}
    `;
export const useUpdateOfferProductPriceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateOfferProductPriceMutation, TError, UpdateOfferProductPriceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateOfferProductPriceMutation, TError, UpdateOfferProductPriceMutationVariables, TContext>(
      ['updateOfferProductPrice'],
      (variables?: UpdateOfferProductPriceMutationVariables) => fetcher<UpdateOfferProductPriceMutation, UpdateOfferProductPriceMutationVariables>(client, UpdateOfferProductPriceDocument, variables, headers)(),
      options
    );
export const OfferByInstallationCodeDocument = `
    query offerByInstallationCode($code: String!) {
  offerByCode(code: $code, purpose: installationAccess) {
    ...OfferByCodeFragment
  }
}
    ${OfferByCodeFragmentFragmentDoc}
${OfferFragmentFragmentDoc}
${BoxSizeFragmentDoc}
${CylinderSizeFragmentDoc}
${CustomerFragmentDoc}
${OfferExpenseFragmentDoc}
${HeatPumpIndoorUnitFragmentDoc}
${CompositeFigureFragmentDoc}
${AddressFragmentDoc}
${OfferDispatchFragmentDoc}
${ResidenceHeatingFragmentDoc}
${RoofFragmentDoc}`;
export const useOfferByInstallationCodeQuery = <
      TData = OfferByInstallationCodeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: OfferByInstallationCodeQueryVariables,
      options?: UseQueryOptions<OfferByInstallationCodeQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<OfferByInstallationCodeQuery, TError, TData>(
      ['offerByInstallationCode', variables],
      fetcher<OfferByInstallationCodeQuery, OfferByInstallationCodeQueryVariables>(client, OfferByInstallationCodeDocument, variables, headers),
      options
    );

useOfferByInstallationCodeQuery.getKey = (variables: OfferByInstallationCodeQueryVariables) => ['offerByInstallationCode', variables];
;

export const OfferBySiteVisitCodeDocument = `
    query offerBySiteVisitCode($code: String!) {
  offerByCode(code: $code, purpose: siteVisitAccess) {
    ...OfferByCodeFragment
  }
}
    ${OfferByCodeFragmentFragmentDoc}
${OfferFragmentFragmentDoc}
${BoxSizeFragmentDoc}
${CylinderSizeFragmentDoc}
${CustomerFragmentDoc}
${OfferExpenseFragmentDoc}
${HeatPumpIndoorUnitFragmentDoc}
${CompositeFigureFragmentDoc}
${AddressFragmentDoc}
${OfferDispatchFragmentDoc}
${ResidenceHeatingFragmentDoc}
${RoofFragmentDoc}`;
export const useOfferBySiteVisitCodeQuery = <
      TData = OfferBySiteVisitCodeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: OfferBySiteVisitCodeQueryVariables,
      options?: UseQueryOptions<OfferBySiteVisitCodeQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<OfferBySiteVisitCodeQuery, TError, TData>(
      ['offerBySiteVisitCode', variables],
      fetcher<OfferBySiteVisitCodeQuery, OfferBySiteVisitCodeQueryVariables>(client, OfferBySiteVisitCodeDocument, variables, headers),
      options
    );

useOfferBySiteVisitCodeQuery.getKey = (variables: OfferBySiteVisitCodeQueryVariables) => ['offerBySiteVisitCode', variables];
;

export const MarkOfferAsSentDocument = `
    mutation markOfferAsSent($offerId: Int!, $type: OfferPDFTypeEnum!) {
  markOfferAsSent(offerID: $offerId, type: $type)
}
    `;
export const useMarkOfferAsSentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MarkOfferAsSentMutation, TError, MarkOfferAsSentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MarkOfferAsSentMutation, TError, MarkOfferAsSentMutationVariables, TContext>(
      ['markOfferAsSent'],
      (variables?: MarkOfferAsSentMutationVariables) => fetcher<MarkOfferAsSentMutation, MarkOfferAsSentMutationVariables>(client, MarkOfferAsSentDocument, variables, headers)(),
      options
    );
export const SetOfferExpensesDocument = `
    mutation setOfferExpenses($offerId: Int!, $expenses: [OfferExpenseInput!]!) {
  setOfferExpenses(offerID: $offerId, expenses: $expenses) {
    id
  }
}
    `;
export const useSetOfferExpensesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetOfferExpensesMutation, TError, SetOfferExpensesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetOfferExpensesMutation, TError, SetOfferExpensesMutationVariables, TContext>(
      ['setOfferExpenses'],
      (variables?: SetOfferExpensesMutationVariables) => fetcher<SetOfferExpensesMutation, SetOfferExpensesMutationVariables>(client, SetOfferExpensesDocument, variables, headers)(),
      options
    );
export const DeleteOfferExpensesDocument = `
    mutation deleteOfferExpenses($offerId: Int!, $expenseIds: [Int!]!) {
  deleteOfferExpenses(offerId: $offerId, expenseIds: $expenseIds)
}
    `;
export const useDeleteOfferExpensesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteOfferExpensesMutation, TError, DeleteOfferExpensesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteOfferExpensesMutation, TError, DeleteOfferExpensesMutationVariables, TContext>(
      ['deleteOfferExpenses'],
      (variables?: DeleteOfferExpensesMutationVariables) => fetcher<DeleteOfferExpensesMutation, DeleteOfferExpensesMutationVariables>(client, DeleteOfferExpensesDocument, variables, headers)(),
      options
    );
export const ExpenseTemplateListDocument = `
    query expenseTemplateList($type: OfferType!) {
  expenseTemplates(type: $type) {
    id
    denominator
    buyPrice
    price
    title
    type
  }
}
    `;
export const useExpenseTemplateListQuery = <
      TData = ExpenseTemplateListQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ExpenseTemplateListQueryVariables,
      options?: UseQueryOptions<ExpenseTemplateListQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ExpenseTemplateListQuery, TError, TData>(
      ['expenseTemplateList', variables],
      fetcher<ExpenseTemplateListQuery, ExpenseTemplateListQueryVariables>(client, ExpenseTemplateListDocument, variables, headers),
      options
    );

useExpenseTemplateListQuery.getKey = (variables: ExpenseTemplateListQueryVariables) => ['expenseTemplateList', variables];
;

export const RegeneratePreviewDocument = `
    mutation regeneratePreview($offerId: Int!, $type: OfferPDFTypeEnum!) {
  regeneratePreview(offerID: $offerId, type: $type)
}
    `;
export const useRegeneratePreviewMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RegeneratePreviewMutation, TError, RegeneratePreviewMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RegeneratePreviewMutation, TError, RegeneratePreviewMutationVariables, TContext>(
      ['regeneratePreview'],
      (variables?: RegeneratePreviewMutationVariables) => fetcher<RegeneratePreviewMutation, RegeneratePreviewMutationVariables>(client, RegeneratePreviewDocument, variables, headers)(),
      options
    );
export const UploadResidenceImagesDocument = `
    mutation uploadResidenceImages($residenceId: Int!, $images: [Upload!]!, $category: String, $code: String) {
  uploadResidenceImages(
    images: $images
    id: $residenceId
    category: $category
    code: $code
  ) {
    residenceID
    category
    url
  }
}
    `;
export const useUploadResidenceImagesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadResidenceImagesMutation, TError, UploadResidenceImagesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadResidenceImagesMutation, TError, UploadResidenceImagesMutationVariables, TContext>(
      ['uploadResidenceImages'],
      (variables?: UploadResidenceImagesMutationVariables) => fetcher<UploadResidenceImagesMutation, UploadResidenceImagesMutationVariables>(client, UploadResidenceImagesDocument, variables, headers)(),
      options
    );
export const DeleteResidenceImageDocument = `
    mutation deleteResidenceImage($residenceId: Int!, $imageUrl: String!, $code: String) {
  deleteResidenceImage(
    residenceID: $residenceId
    imageUrl: $imageUrl
    code: $code
  )
}
    `;
export const useDeleteResidenceImageMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteResidenceImageMutation, TError, DeleteResidenceImageMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteResidenceImageMutation, TError, DeleteResidenceImageMutationVariables, TContext>(
      ['deleteResidenceImage'],
      (variables?: DeleteResidenceImageMutationVariables) => fetcher<DeleteResidenceImageMutation, DeleteResidenceImageMutationVariables>(client, DeleteResidenceImageDocument, variables, headers)(),
      options
    );
export const UpsertResidenceDocument = `
    mutation upsertResidence($customerId: Int!, $residence: ResidenceInput!, $residenceId: Int) {
  upsertResidence(
    customerID: $customerId
    residence: $residence
    id: $residenceId
  ) {
    id
  }
}
    `;
export const useUpsertResidenceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpsertResidenceMutation, TError, UpsertResidenceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpsertResidenceMutation, TError, UpsertResidenceMutationVariables, TContext>(
      ['upsertResidence'],
      (variables?: UpsertResidenceMutationVariables) => fetcher<UpsertResidenceMutation, UpsertResidenceMutationVariables>(client, UpsertResidenceDocument, variables, headers)(),
      options
    );
export const ResidenceDocument = `
    query residence($residenceId: Int) {
  residence(id: $residenceId) {
    id
    address {
      ...Address
    }
    addressID
    area
    areaHeated
    areaNotHeated
    areaPartiallyHeated
    builtYear
    consumption {
      profileKey
      profileValue
    }
    consumptionProfile
    createdAt
    customer {
      id
      createdAt
      eligibleForFinancing
      name
    }
    customerID
    electricCar {
      annualKilometersDriven
      consumptionPerKilometer
      id
      percentageCharged
      monthlySubscriptionPrice
      isSubsidised
    }
    electricityPrice
    energyExpenditure
    energyLabel
    floors
    heatDistribution
    heatingCircuits
    id
    images {
      id
      residenceID
      category
      url
    }
    monthlyConsumption {
      profileKey
      profileValue
    }
    monthlyConsumptionProfile
    noiseWeight
    primaryHeating {
      ...ResidenceHeating
    }
    radiatorFloorPercentage
    renovatedDegree
    renovatedYear
    residents
    roofs {
      ...Roof
    }
    roofType
    secondaryHeating {
      ...ResidenceHeating
    }
    type
    updatedAt
    waterConsumption
    hasExistingSolarPanels
  }
}
    ${AddressFragmentDoc}
${ResidenceHeatingFragmentDoc}
${RoofFragmentDoc}`;
export const useResidenceQuery = <
      TData = ResidenceQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ResidenceQueryVariables,
      options?: UseQueryOptions<ResidenceQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ResidenceQuery, TError, TData>(
      variables === undefined ? ['residence'] : ['residence', variables],
      fetcher<ResidenceQuery, ResidenceQueryVariables>(client, ResidenceDocument, variables, headers),
      options
    );

useResidenceQuery.getKey = (variables?: ResidenceQueryVariables) => variables === undefined ? ['residence'] : ['residence', variables];
;

export const ResidenceListDocument = `
    query residenceList($customerId: Int) {
  residences(customerID: $customerId) {
    id
    address {
      ...Address
    }
  }
}
    ${AddressFragmentDoc}`;
export const useResidenceListQuery = <
      TData = ResidenceListQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ResidenceListQueryVariables,
      options?: UseQueryOptions<ResidenceListQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ResidenceListQuery, TError, TData>(
      variables === undefined ? ['residenceList'] : ['residenceList', variables],
      fetcher<ResidenceListQuery, ResidenceListQueryVariables>(client, ResidenceListDocument, variables, headers),
      options
    );

useResidenceListQuery.getKey = (variables?: ResidenceListQueryVariables) => variables === undefined ? ['residenceList'] : ['residenceList', variables];
;

export const SetResidenceRoofTypeDocument = `
    mutation setResidenceRoofType($residenceId: Int!, $roofType: RoofType!) {
  setResidenceRoofType(residenceId: $residenceId, roofType: $roofType)
}
    `;
export const useSetResidenceRoofTypeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetResidenceRoofTypeMutation, TError, SetResidenceRoofTypeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetResidenceRoofTypeMutation, TError, SetResidenceRoofTypeMutationVariables, TContext>(
      ['setResidenceRoofType'],
      (variables?: SetResidenceRoofTypeMutationVariables) => fetcher<SetResidenceRoofTypeMutation, SetResidenceRoofTypeMutationVariables>(client, SetResidenceRoofTypeDocument, variables, headers)(),
      options
    );
export const OfferSavingsDocument = `
    query offerSavings($residence: ResidenceInput!, $offer: OfferInput!, $address: AddressInput, $chosenHeating: Float, $consumptionProfile: [Float!], $customerID: Float) {
  offerSavings(
    residence: $residence
    offer: $offer
    address: $address
    chosenHeating: $chosenHeating
    consumptionProfile: $consumptionProfile
    customerID: $customerID
  ) {
    before {
      ...ProductUsage
    }
    after {
      ...ProductUsage
    }
    saved {
      price
      emission
      priceByYear
    }
  }
}
    ${ProductUsageFragmentDoc}`;
export const useOfferSavingsQuery = <
      TData = OfferSavingsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: OfferSavingsQueryVariables,
      options?: UseQueryOptions<OfferSavingsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<OfferSavingsQuery, TError, TData>(
      ['offerSavings', variables],
      fetcher<OfferSavingsQuery, OfferSavingsQueryVariables>(client, OfferSavingsDocument, variables, headers),
      options
    );

useOfferSavingsQuery.getKey = (variables: OfferSavingsQueryVariables) => ['offerSavings', variables];
;

export const SolarPackageSavingsDocument = `
    query solarPackageSavings($residence: ResidenceInput!) {
  solarPackageSavings(residence: $residence) {
    packageID
    title
    savings
    usedPercentage
    quantity
    totalPrice
    totalSaved
  }
}
    `;
export const useSolarPackageSavingsQuery = <
      TData = SolarPackageSavingsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SolarPackageSavingsQueryVariables,
      options?: UseQueryOptions<SolarPackageSavingsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SolarPackageSavingsQuery, TError, TData>(
      ['solarPackageSavings', variables],
      fetcher<SolarPackageSavingsQuery, SolarPackageSavingsQueryVariables>(client, SolarPackageSavingsDocument, variables, headers),
      options
    );

useSolarPackageSavingsQuery.getKey = (variables: SolarPackageSavingsQueryVariables) => ['solarPackageSavings', variables];
;

export const OfferSavingsWithAndWithoutBatteryDocument = `
    query offerSavingsWithAndWithoutBattery($residence: ResidenceInput!, $offerWithBattery: OfferInput!, $offerWithoutBattery: OfferInput!, $address: AddressInput, $chosenHeating: Float, $consumptionProfile: [Float!], $customerID: Float) {
  withBattery: offerSavings(
    residence: $residence
    offer: $offerWithBattery
    address: $address
    chosenHeating: $chosenHeating
    consumptionProfile: $consumptionProfile
    customerID: $customerID
  ) {
    before {
      ...ProductUsage
    }
    after {
      ...ProductUsage
    }
    saved {
      price
      emission
    }
  }
  withoutBattery: offerSavings(
    residence: $residence
    offer: $offerWithoutBattery
    address: $address
    chosenHeating: $chosenHeating
    consumptionProfile: $consumptionProfile
    customerID: $customerID
  ) {
    before {
      ...ProductUsage
    }
    after {
      ...ProductUsage
    }
    saved {
      price
      emission
    }
  }
}
    ${ProductUsageFragmentDoc}`;
export const useOfferSavingsWithAndWithoutBatteryQuery = <
      TData = OfferSavingsWithAndWithoutBatteryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: OfferSavingsWithAndWithoutBatteryQueryVariables,
      options?: UseQueryOptions<OfferSavingsWithAndWithoutBatteryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<OfferSavingsWithAndWithoutBatteryQuery, TError, TData>(
      ['offerSavingsWithAndWithoutBattery', variables],
      fetcher<OfferSavingsWithAndWithoutBatteryQuery, OfferSavingsWithAndWithoutBatteryQueryVariables>(client, OfferSavingsWithAndWithoutBatteryDocument, variables, headers),
      options
    );

useOfferSavingsWithAndWithoutBatteryQuery.getKey = (variables: OfferSavingsWithAndWithoutBatteryQueryVariables) => ['offerSavingsWithAndWithoutBattery', variables];
;

export const UpdateSiteVisitAnswerListDocument = `
    mutation updateSiteVisitAnswerList($answerList: [SiteVisitAnswerInput!]!, $code: String) {
  upsertSiteVisitAnswerList(answerList: $answerList, code: $code)
}
    `;
export const useUpdateSiteVisitAnswerListMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateSiteVisitAnswerListMutation, TError, UpdateSiteVisitAnswerListMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateSiteVisitAnswerListMutation, TError, UpdateSiteVisitAnswerListMutationVariables, TContext>(
      ['updateSiteVisitAnswerList'],
      (variables?: UpdateSiteVisitAnswerListMutationVariables) => fetcher<UpdateSiteVisitAnswerListMutation, UpdateSiteVisitAnswerListMutationVariables>(client, UpdateSiteVisitAnswerListDocument, variables, headers)(),
      options
    );
export const SiteVisitAnswerListDocument = `
    query siteVisitAnswerList($residenceId: Int!) {
  siteVisitAnswerList(residenceID: $residenceId) {
    answer
    id
    question
    residenceId
  }
}
    `;
export const useSiteVisitAnswerListQuery = <
      TData = SiteVisitAnswerListQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SiteVisitAnswerListQueryVariables,
      options?: UseQueryOptions<SiteVisitAnswerListQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SiteVisitAnswerListQuery, TError, TData>(
      ['siteVisitAnswerList', variables],
      fetcher<SiteVisitAnswerListQuery, SiteVisitAnswerListQueryVariables>(client, SiteVisitAnswerListDocument, variables, headers),
      options
    );

useSiteVisitAnswerListQuery.getKey = (variables: SiteVisitAnswerListQueryVariables) => ['siteVisitAnswerList', variables];
;

export const UploadSiteVisitFileDocument = `
    mutation uploadSiteVisitFile($file: Upload!, $offerID: Int!, $code: String) {
  uploadSiteVisitFile(file: $file, offerID: $offerID, code: $code)
}
    `;
export const useUploadSiteVisitFileMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadSiteVisitFileMutation, TError, UploadSiteVisitFileMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadSiteVisitFileMutation, TError, UploadSiteVisitFileMutationVariables, TContext>(
      ['uploadSiteVisitFile'],
      (variables?: UploadSiteVisitFileMutationVariables) => fetcher<UploadSiteVisitFileMutation, UploadSiteVisitFileMutationVariables>(client, UploadSiteVisitFileDocument, variables, headers)(),
      options
    );
export const DeleteSiteVisitFileDocument = `
    mutation deleteSiteVisitFile($id: Int!, $code: String) {
  deleteSiteVisitFile(id: $id, code: $code)
}
    `;
export const useDeleteSiteVisitFileMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteSiteVisitFileMutation, TError, DeleteSiteVisitFileMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteSiteVisitFileMutation, TError, DeleteSiteVisitFileMutationVariables, TContext>(
      ['deleteSiteVisitFile'],
      (variables?: DeleteSiteVisitFileMutationVariables) => fetcher<DeleteSiteVisitFileMutation, DeleteSiteVisitFileMutationVariables>(client, DeleteSiteVisitFileDocument, variables, headers)(),
      options
    );
export const SiteVisitFilesDocument = `
    query siteVisitFiles($offerID: Int!) {
  siteVisitFiles(offerID: $offerID) {
    id
    offerID
    url
    name
  }
}
    `;
export const useSiteVisitFilesQuery = <
      TData = SiteVisitFilesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SiteVisitFilesQueryVariables,
      options?: UseQueryOptions<SiteVisitFilesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SiteVisitFilesQuery, TError, TData>(
      ['siteVisitFiles', variables],
      fetcher<SiteVisitFilesQuery, SiteVisitFilesQueryVariables>(client, SiteVisitFilesDocument, variables, headers),
      options
    );

useSiteVisitFilesQuery.getKey = (variables: SiteVisitFilesQueryVariables) => ['siteVisitFiles', variables];
;

export const SolarPanelsDocument = `
    query solarPanels($ids: [Int!]) {
  solarPanels(ids: $ids) {
    ...SolarPanel
  }
}
    ${SolarPanelFragmentDoc}
${BoxSizeFragmentDoc}`;
export const useSolarPanelsQuery = <
      TData = SolarPanelsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: SolarPanelsQueryVariables,
      options?: UseQueryOptions<SolarPanelsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SolarPanelsQuery, TError, TData>(
      variables === undefined ? ['solarPanels'] : ['solarPanels', variables],
      fetcher<SolarPanelsQuery, SolarPanelsQueryVariables>(client, SolarPanelsDocument, variables, headers),
      options
    );

useSolarPanelsQuery.getKey = (variables?: SolarPanelsQueryVariables) => variables === undefined ? ['solarPanels'] : ['solarPanels', variables];
;

export const SolarProductPackagesDocument = `
    query solarProductPackages {
  solarProductPackages(onlyDefaultBattery: true, isAdvisor: true) {
    packageID
    discount
    discountWithoutInstallation
    title
    defaultBatteryID
    solarPanel {
      ...SolarPanel
    }
    inverter {
      ...Inverter
    }
    batteries {
      ...Battery
    }
  }
}
    ${SolarPanelFragmentDoc}
${BoxSizeFragmentDoc}
${InverterFragmentDoc}
${CylinderSizeFragmentDoc}
${BatteryFragmentDoc}`;
export const useSolarProductPackagesQuery = <
      TData = SolarProductPackagesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: SolarProductPackagesQueryVariables,
      options?: UseQueryOptions<SolarProductPackagesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SolarProductPackagesQuery, TError, TData>(
      variables === undefined ? ['solarProductPackages'] : ['solarProductPackages', variables],
      fetcher<SolarProductPackagesQuery, SolarProductPackagesQueryVariables>(client, SolarProductPackagesDocument, variables, headers),
      options
    );

useSolarProductPackagesQuery.getKey = (variables?: SolarProductPackagesQueryVariables) => variables === undefined ? ['solarProductPackages'] : ['solarProductPackages', variables];
;

export const RecommendedSolarPackageDocument = `
    query recommendedSolarPackage($residence: ResidenceInput!) {
  recommendedSolarPackage(residence: $residence) {
    solarPanel {
      ...SolarPanel
    }
    inverter {
      ...Inverter
    }
    batteries {
      ...Battery
    }
    discount
    discountWithoutInstallation
  }
}
    ${SolarPanelFragmentDoc}
${BoxSizeFragmentDoc}
${InverterFragmentDoc}
${CylinderSizeFragmentDoc}
${BatteryFragmentDoc}`;
export const useRecommendedSolarPackageQuery = <
      TData = RecommendedSolarPackageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: RecommendedSolarPackageQueryVariables,
      options?: UseQueryOptions<RecommendedSolarPackageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<RecommendedSolarPackageQuery, TError, TData>(
      ['recommendedSolarPackage', variables],
      fetcher<RecommendedSolarPackageQuery, RecommendedSolarPackageQueryVariables>(client, RecommendedSolarPackageDocument, variables, headers),
      options
    );

useRecommendedSolarPackageQuery.getKey = (variables: RecommendedSolarPackageQueryVariables) => ['recommendedSolarPackage', variables];
;

export const UserDocument = `
    query user {
  me {
    id
    name
    isAdmin
  }
}
    `;
export const useUserQuery = <
      TData = UserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: UserQueryVariables,
      options?: UseQueryOptions<UserQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<UserQuery, TError, TData>(
      variables === undefined ? ['user'] : ['user', variables],
      fetcher<UserQuery, UserQueryVariables>(client, UserDocument, variables, headers),
      options
    );

useUserQuery.getKey = (variables?: UserQueryVariables) => variables === undefined ? ['user'] : ['user', variables];
;

export const BodilAdvisorListDocument = `
    query bodilAdvisorList {
  bodilAdvisors {
    firstName
    lastName
    id
  }
}
    `;
export const useBodilAdvisorListQuery = <
      TData = BodilAdvisorListQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: BodilAdvisorListQueryVariables,
      options?: UseQueryOptions<BodilAdvisorListQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<BodilAdvisorListQuery, TError, TData>(
      variables === undefined ? ['bodilAdvisorList'] : ['bodilAdvisorList', variables],
      fetcher<BodilAdvisorListQuery, BodilAdvisorListQueryVariables>(client, BodilAdvisorListDocument, variables, headers),
      options
    );

useBodilAdvisorListQuery.getKey = (variables?: BodilAdvisorListQueryVariables) => variables === undefined ? ['bodilAdvisorList'] : ['bodilAdvisorList', variables];
;
